// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/morgans/v1/morgans.proto (package mono.morgans.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { MarketDensityPoint, Seat, SeatRound, SuggestedRound } from "../../datagateway/v1/seats_pb";
/**
 * @generated from enum mono.morgans.v1.UsaspendingContractScope
 */ export var UsaspendingContractScope = /*#__PURE__*/ function(UsaspendingContractScope) {
    /**
   * @generated from enum value: USASPENDING_CONTRACT_SCOPE_UNSPECIFIED = 0;
   */ UsaspendingContractScope[UsaspendingContractScope["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * scope_ref = awarding toptier agency name
   *
   * @generated from enum value: USASPENDING_CONTRACT_SCOPE_AGENCY = 1;
   */ UsaspendingContractScope[UsaspendingContractScope["AGENCY"] = 1] = "AGENCY";
    /**
   * scope_ref = recipient UEI
   *
   * @generated from enum value: USASPENDING_CONTRACT_SCOPE_COMPANY = 2;
   */ UsaspendingContractScope[UsaspendingContractScope["COMPANY"] = 2] = "COMPANY";
    /**
   * scope_ref = referenced IDV PIID
   *
   * @generated from enum value: USASPENDING_CONTRACT_SCOPE_VEHICLE = 3;
   */ UsaspendingContractScope[UsaspendingContractScope["VEHICLE"] = 3] = "VEHICLE";
    return UsaspendingContractScope;
}({});
// Retrieve enum metadata with: proto3.getEnumType(UsaspendingContractScope)
proto3.util.setEnumType(UsaspendingContractScope, "mono.morgans.v1.UsaspendingContractScope", [
    {
        no: 0,
        name: "USASPENDING_CONTRACT_SCOPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "USASPENDING_CONTRACT_SCOPE_AGENCY"
    },
    {
        no: 2,
        name: "USASPENDING_CONTRACT_SCOPE_COMPANY"
    },
    {
        no: 3,
        name: "USASPENDING_CONTRACT_SCOPE_VEHICLE"
    }
]);
/**
 * @generated from enum mono.morgans.v1.LandscapeCriterionKind
 */ export var LandscapeCriterionKind = /*#__PURE__*/ function(LandscapeCriterionKind) {
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_UNSPECIFIED = 0;
   */ LandscapeCriterionKind[LandscapeCriterionKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_AGENCY = 1;
   */ LandscapeCriterionKind[LandscapeCriterionKind["AGENCY"] = 1] = "AGENCY";
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_NAICS = 2;
   */ LandscapeCriterionKind[LandscapeCriterionKind["NAICS"] = 2] = "NAICS";
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_PSC = 3;
   */ LandscapeCriterionKind[LandscapeCriterionKind["PSC"] = 3] = "PSC";
    /**
   * @generated from enum value: LANDSCAPE_CRITERION_KIND_CAPABILITY = 4;
   */ LandscapeCriterionKind[LandscapeCriterionKind["CAPABILITY"] = 4] = "CAPABILITY";
    return LandscapeCriterionKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(LandscapeCriterionKind)
proto3.util.setEnumType(LandscapeCriterionKind, "mono.morgans.v1.LandscapeCriterionKind", [
    {
        no: 0,
        name: "LANDSCAPE_CRITERION_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "LANDSCAPE_CRITERION_KIND_AGENCY"
    },
    {
        no: 2,
        name: "LANDSCAPE_CRITERION_KIND_NAICS"
    },
    {
        no: 3,
        name: "LANDSCAPE_CRITERION_KIND_PSC"
    },
    {
        no: 4,
        name: "LANDSCAPE_CRITERION_KIND_CAPABILITY"
    }
]);
/**
 * @generated from enum mono.morgans.v1.VehicleNoticeStatus
 */ export var VehicleNoticeStatus = /*#__PURE__*/ function(VehicleNoticeStatus) {
    /**
   * @generated from enum value: VEHICLE_NOTICE_STATUS_UNSPECIFIED = 0;
   */ VehicleNoticeStatus[VehicleNoticeStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: VEHICLE_NOTICE_STATUS_NEW = 1;
   */ VehicleNoticeStatus[VehicleNoticeStatus["NEW"] = 1] = "NEW";
    /**
   * @generated from enum value: VEHICLE_NOTICE_STATUS_WATCHING = 2;
   */ VehicleNoticeStatus[VehicleNoticeStatus["WATCHING"] = 2] = "WATCHING";
    /**
   * @generated from enum value: VEHICLE_NOTICE_STATUS_DUE = 3;
   */ VehicleNoticeStatus[VehicleNoticeStatus["DUE"] = 3] = "DUE";
    return VehicleNoticeStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(VehicleNoticeStatus)
proto3.util.setEnumType(VehicleNoticeStatus, "mono.morgans.v1.VehicleNoticeStatus", [
    {
        no: 0,
        name: "VEHICLE_NOTICE_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "VEHICLE_NOTICE_STATUS_NEW"
    },
    {
        no: 2,
        name: "VEHICLE_NOTICE_STATUS_WATCHING"
    },
    {
        no: 3,
        name: "VEHICLE_NOTICE_STATUS_DUE"
    }
]);
/**
 * @generated from message mono.morgans.v1.BackfillAgencyGraphRequest
 */ export class BackfillAgencyGraphRequest extends Message {
    static fromBinary(bytes, options) {
        return new BackfillAgencyGraphRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BackfillAgencyGraphRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BackfillAgencyGraphRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BackfillAgencyGraphRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * awarding toptier agency to backfill
   *
   * @generated from field: string agency_name = 2;
   */ _define_property(this, "agencyName", ""), /**
   * YYYY-MM-DD (defaults to a wide window when empty)
   *
   * @generated from field: string start_date = 3;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 4;
   */ _define_property(this, "endDate", ""), /**
   * cap per source
   *
   * @generated from field: int32 max_records = 5;
   */ _define_property(this, "maxRecords", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BackfillAgencyGraphRequest, "runtime", proto3);
_define_property(BackfillAgencyGraphRequest, "typeName", "mono.morgans.v1.BackfillAgencyGraphRequest");
_define_property(BackfillAgencyGraphRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "max_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.BackfillAgencyGraphResponse
 */ export class BackfillAgencyGraphResponse extends Message {
    static fromBinary(bytes, options) {
        return new BackfillAgencyGraphResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BackfillAgencyGraphResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BackfillAgencyGraphResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BackfillAgencyGraphResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 awards_fetched = 1;
   */ _define_property(this, "awardsFetched", 0), /**
   * @generated from field: int32 vehicles_fetched = 2;
   */ _define_property(this, "vehiclesFetched", 0), /**
   * @generated from field: int32 nodes_created = 3;
   */ _define_property(this, "nodesCreated", 0), /**
   * @generated from field: int32 nodes_updated = 4;
   */ _define_property(this, "nodesUpdated", 0), /**
   * @generated from field: int32 edges_created = 5;
   */ _define_property(this, "edgesCreated", 0), /**
   * @generated from field: int32 edges_skipped = 6;
   */ _define_property(this, "edgesSkipped", 0), /**
   * @generated from field: int32 companies_reconciled = 7;
   */ _define_property(this, "companiesReconciled", 0), /**
   * @generated from field: int32 vehicles_reconciled = 8;
   */ _define_property(this, "vehiclesReconciled", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BackfillAgencyGraphResponse, "runtime", proto3);
_define_property(BackfillAgencyGraphResponse, "typeName", "mono.morgans.v1.BackfillAgencyGraphResponse");
_define_property(BackfillAgencyGraphResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awards_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "vehicles_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "nodes_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "nodes_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "edges_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "edges_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "companies_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "vehicles_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingVehiclesRequest
 */ export class IngestUsaspendingVehiclesRequest extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingVehiclesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingVehiclesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingVehiclesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingVehiclesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * optional: limit to one awarding toptier agency
   *
   * @generated from field: string agency_name = 2;
   */ _define_property(this, "agencyName", ""), /**
   * YYYY-MM-DD (defaults to a wide window when empty)
   *
   * @generated from field: string start_date = 3;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 4;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: int32 max_records = 5;
   */ _define_property(this, "maxRecords", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingVehiclesRequest, "runtime", proto3);
_define_property(IngestUsaspendingVehiclesRequest, "typeName", "mono.morgans.v1.IngestUsaspendingVehiclesRequest");
_define_property(IngestUsaspendingVehiclesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "max_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingVehiclesResponse
 */ export class IngestUsaspendingVehiclesResponse extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingVehiclesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingVehiclesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingVehiclesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingVehiclesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 vehicles_fetched = 1;
   */ _define_property(this, "vehiclesFetched", 0), /**
   * @generated from field: int32 nodes_created = 2;
   */ _define_property(this, "nodesCreated", 0), /**
   * @generated from field: int32 nodes_updated = 3;
   */ _define_property(this, "nodesUpdated", 0), /**
   * @generated from field: int32 edges_created = 4;
   */ _define_property(this, "edgesCreated", 0), /**
   * @generated from field: int32 edges_skipped = 5;
   */ _define_property(this, "edgesSkipped", 0), /**
   * @generated from field: int32 companies_reconciled = 6;
   */ _define_property(this, "companiesReconciled", 0), /**
   * @generated from field: int32 vehicles_reconciled = 7;
   */ _define_property(this, "vehiclesReconciled", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingVehiclesResponse, "runtime", proto3);
_define_property(IngestUsaspendingVehiclesResponse, "typeName", "mono.morgans.v1.IngestUsaspendingVehiclesResponse");
_define_property(IngestUsaspendingVehiclesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicles_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "nodes_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "nodes_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "edges_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "edges_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "companies_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "vehicles_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestSamOpportunitiesRequest
 */ export class IngestSamOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new IngestSamOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestSamOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestSamOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestSamOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string posted_from = 2;
   */ _define_property(this, "postedFrom", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string posted_to = 3;
   */ _define_property(this, "postedTo", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestSamOpportunitiesRequest, "runtime", proto3);
_define_property(IngestSamOpportunitiesRequest, "typeName", "mono.morgans.v1.IngestSamOpportunitiesRequest");
_define_property(IngestSamOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "posted_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "posted_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestSamOpportunitiesResponse
 */ export class IngestSamOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new IngestSamOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestSamOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestSamOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestSamOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 awards_fetched = 1;
   */ _define_property(this, "awardsFetched", 0), /**
   * @generated from field: int32 nodes_created = 2;
   */ _define_property(this, "nodesCreated", 0), /**
   * @generated from field: int32 nodes_updated = 3;
   */ _define_property(this, "nodesUpdated", 0), /**
   * @generated from field: int32 edges_created = 4;
   */ _define_property(this, "edgesCreated", 0), /**
   * @generated from field: int32 edges_skipped = 5;
   */ _define_property(this, "edgesSkipped", 0), /**
   * @generated from field: int32 companies_reconciled = 6;
   */ _define_property(this, "companiesReconciled", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestSamOpportunitiesResponse, "runtime", proto3);
_define_property(IngestSamOpportunitiesResponse, "typeName", "mono.morgans.v1.IngestSamOpportunitiesResponse");
_define_property(IngestSamOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awards_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "nodes_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "nodes_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "edges_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "edges_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "companies_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingAwardsRequest
 */ export class IngestUsaspendingAwardsRequest extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingAwardsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingAwardsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingAwardsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingAwardsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Filters mapped onto the USAspending award search; all optional.
   *
   * company name/UEI substrings
   *
   * @generated from field: repeated string recipient_search_text = 2;
   */ _define_property(this, "recipientSearchText", []), /**
   * awarding toptier agency
   *
   * @generated from field: string agency_name = 3;
   */ _define_property(this, "agencyName", ""), /**
   * @generated from field: repeated string naics_codes = 4;
   */ _define_property(this, "naicsCodes", []), /**
   * @generated from field: repeated string psc_codes = 5;
   */ _define_property(this, "pscCodes", []), /**
   * YYYY-MM-DD (defaults to a wide window when empty)
   *
   * @generated from field: string start_date = 6;
   */ _define_property(this, "startDate", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string end_date = 7;
   */ _define_property(this, "endDate", ""), /**
   * cap on awards pulled (server clamps)
   *
   * @generated from field: int32 max_records = 8;
   */ _define_property(this, "maxRecords", 0), /**
   * Caller-supplied award records. When non-empty the external USAspending
   * fetch is skipped and these are normalized + ingested directly — lets a
   * caller push curated/cached records (and gives integration tests a
   * deterministic, network-free path through the connector).
   *
   * @generated from field: repeated mono.morgans.v1.FixtureAward fixture_awards = 9;
   */ _define_property(this, "fixtureAwards", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingAwardsRequest, "runtime", proto3);
_define_property(IngestUsaspendingAwardsRequest, "typeName", "mono.morgans.v1.IngestUsaspendingAwardsRequest");
_define_property(IngestUsaspendingAwardsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recipient_search_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "naics_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "psc_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "max_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "fixture_awards",
            kind: "message",
            T: FixtureAward,
            repeated: true
        }
    ]));
/**
 * FixtureAward is the minimal award shape the normalizer reads (recipient +
 * awarding agency chain). Used by IngestUsaspendingAwardsRequest.fixture_awards.
 *
 * @generated from message mono.morgans.v1.FixtureAward
 */ export class FixtureAward extends Message {
    static fromBinary(bytes, options) {
        return new FixtureAward().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FixtureAward().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FixtureAward().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FixtureAward, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string recipient_name = 1;
   */ _define_property(this, "recipientName", ""), /**
   * @generated from field: string recipient_uei = 2;
   */ _define_property(this, "recipientUei", ""), /**
   * toptier agency
   *
   * @generated from field: string awarding_agency = 3;
   */ _define_property(this, "awardingAgency", ""), /**
   * optional sub-agency / bureau
   *
   * @generated from field: string awarding_sub_agency = 4;
   */ _define_property(this, "awardingSubAgency", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FixtureAward, "runtime", proto3);
_define_property(FixtureAward, "typeName", "mono.morgans.v1.FixtureAward");
_define_property(FixtureAward, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "recipient_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recipient_uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "awarding_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "awarding_sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingAwardsResponse
 */ export class IngestUsaspendingAwardsResponse extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingAwardsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingAwardsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingAwardsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingAwardsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 awards_fetched = 1;
   */ _define_property(this, "awardsFetched", 0), /**
   * @generated from field: int32 nodes_created = 2;
   */ _define_property(this, "nodesCreated", 0), /**
   * @generated from field: int32 nodes_updated = 3;
   */ _define_property(this, "nodesUpdated", 0), /**
   * @generated from field: int32 edges_created = 4;
   */ _define_property(this, "edgesCreated", 0), /**
   * @generated from field: int32 edges_skipped = 5;
   */ _define_property(this, "edgesSkipped", 0), /**
   * @generated from field: int32 companies_reconciled = 6;
   */ _define_property(this, "companiesReconciled", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingAwardsResponse, "runtime", proto3);
_define_property(IngestUsaspendingAwardsResponse, "typeName", "mono.morgans.v1.IngestUsaspendingAwardsResponse");
_define_property(IngestUsaspendingAwardsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awards_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "nodes_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "nodes_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "edges_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "edges_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "companies_reconciled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingContractsRequest
 */ export class IngestUsaspendingContractsRequest extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingContractsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingContractsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingContractsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingContractsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: mono.morgans.v1.UsaspendingContractScope scope_kind = 2;
   */ _define_property(this, "scopeKind", 0), /**
   * @generated from field: string scope_ref = 3;
   */ _define_property(this, "scopeRef", ""), /**
   * First fiscal year of the window; 0 = the last 8 fiscal years.
   *
   * @generated from field: int32 from_fy = 4;
   */ _define_property(this, "fromFy", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingContractsRequest, "runtime", proto3);
_define_property(IngestUsaspendingContractsRequest, "typeName", "mono.morgans.v1.IngestUsaspendingContractsRequest");
_define_property(IngestUsaspendingContractsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope_kind",
            kind: "enum",
            T: proto3.getEnumType(UsaspendingContractScope)
        },
        {
            no: 3,
            name: "scope_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "from_fy",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.IngestUsaspendingContractsResponse
 */ export class IngestUsaspendingContractsResponse extends Message {
    static fromBinary(bytes, options) {
        return new IngestUsaspendingContractsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IngestUsaspendingContractsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IngestUsaspendingContractsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IngestUsaspendingContractsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 awards_fetched = 1;
   */ _define_property(this, "awardsFetched", 0), /**
   * @generated from field: int32 contracts_upserted = 2;
   */ _define_property(this, "contractsUpserted", 0), /**
   * @generated from field: int32 observations_written = 3;
   */ _define_property(this, "observationsWritten", 0), /**
   * @generated from field: int32 companies_matched = 4;
   */ _define_property(this, "companiesMatched", 0), /**
   * detail missing or identity incomplete
   *
   * @generated from field: int32 awards_skipped = 5;
   */ _define_property(this, "awardsSkipped", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IngestUsaspendingContractsResponse, "runtime", proto3);
_define_property(IngestUsaspendingContractsResponse, "typeName", "mono.morgans.v1.IngestUsaspendingContractsResponse");
_define_property(IngestUsaspendingContractsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "awards_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "contracts_upserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "observations_written",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "companies_matched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "awards_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TriggerScrapeRequest
 */ export class TriggerScrapeRequest extends Message {
    static fromBinary(bytes, options) {
        return new TriggerScrapeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TriggerScrapeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TriggerScrapeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TriggerScrapeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string posted_from = 1;
   */ _define_property(this, "postedFrom", ""), /**
   * @generated from field: string posted_to = 2;
   */ _define_property(this, "postedTo", ""), /**
   * @generated from field: int32 max_records = 3;
   */ _define_property(this, "maxRecords", 0), /**
   * @generated from field: bool skip_embedding = 4;
   */ _define_property(this, "skipEmbedding", false), /**
   * @generated from field: bool skip_summaries = 5;
   */ _define_property(this, "skipSummaries", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TriggerScrapeRequest, "runtime", proto3);
_define_property(TriggerScrapeRequest, "typeName", "mono.morgans.v1.TriggerScrapeRequest");
_define_property(TriggerScrapeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "posted_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "posted_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "max_records",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "skip_embedding",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "skip_summaries",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TriggerScrapeResponse
 */ export class TriggerScrapeResponse extends Message {
    static fromBinary(bytes, options) {
        return new TriggerScrapeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TriggerScrapeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TriggerScrapeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TriggerScrapeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string message = 3;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TriggerScrapeResponse, "runtime", proto3);
_define_property(TriggerScrapeResponse, "typeName", "mono.morgans.v1.TriggerScrapeResponse");
_define_property(TriggerScrapeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetScrapeStatusRequest
 */ export class GetScrapeStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetScrapeStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetScrapeStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetScrapeStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetScrapeStatusRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetScrapeStatusRequest, "runtime", proto3);
_define_property(GetScrapeStatusRequest, "typeName", "mono.morgans.v1.GetScrapeStatusRequest");
_define_property(GetScrapeStatusRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.GetScrapeStatusResponse
 */ export class GetScrapeStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetScrapeStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetScrapeStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetScrapeStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetScrapeStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string status = 1;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string job_id = 2;
   */ _define_property(this, "jobId", ""), /**
   * @generated from field: google.protobuf.Timestamp started_at = 3;
   */ _define_property(this, "startedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 4;
   */ _define_property(this, "completedAt", void 0), /**
   * @generated from field: mono.morgans.v1.ScrapeStats stats = 5;
   */ _define_property(this, "stats", void 0), /**
   * @generated from field: string error_message = 6;
   */ _define_property(this, "errorMessage", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetScrapeStatusResponse, "runtime", proto3);
_define_property(GetScrapeStatusResponse, "typeName", "mono.morgans.v1.GetScrapeStatusResponse");
_define_property(GetScrapeStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "started_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "stats",
            kind: "message",
            T: ScrapeStats
        },
        {
            no: 6,
            name: "error_message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ScrapeStats
 */ export class ScrapeStats extends Message {
    static fromBinary(bytes, options) {
        return new ScrapeStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScrapeStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScrapeStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScrapeStats, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_fetched = 1;
   */ _define_property(this, "totalFetched", 0), /**
   * @generated from field: int32 created = 2;
   */ _define_property(this, "created", 0), /**
   * @generated from field: int32 updated = 3;
   */ _define_property(this, "updated", 0), /**
   * @generated from field: int32 skipped = 4;
   */ _define_property(this, "skipped", 0), /**
   * @generated from field: int32 embedded = 5;
   */ _define_property(this, "embedded", 0), /**
   * @generated from field: int32 summaries_generated = 6;
   */ _define_property(this, "summariesGenerated", 0), /**
   * @generated from field: int32 errors = 7;
   */ _define_property(this, "errors", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScrapeStats, "runtime", proto3);
_define_property(ScrapeStats, "typeName", "mono.morgans.v1.ScrapeStats");
_define_property(ScrapeStats, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_fetched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "embedded",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "summaries_generated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "errors",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListOpportunitiesRequest
 */ export class ListOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 limit = 1;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: string search = 3;
   */ _define_property(this, "search", ""), /**
   * @generated from field: string agency = 4;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string set_aside_type = 5;
   */ _define_property(this, "setAsideType", ""), /**
   * @generated from field: string naics_code = 6;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: string posted_after = 7;
   */ _define_property(this, "postedAfter", ""), /**
   * @generated from field: string deadline_before = 8;
   */ _define_property(this, "deadlineBefore", ""), /**
   * @generated from field: string sort_by = 9;
   */ _define_property(this, "sortBy", ""), /**
   * @generated from field: string sort_order = 10;
   */ _define_property(this, "sortOrder", ""), /**
   * @generated from field: bool active_only = 11;
   */ _define_property(this, "activeOnly", false), /**
   * User tracking filters (MongoDB-backed)
   *
   * @generated from field: string user_id = 12;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 13;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: bool saved_only = 14;
   */ _define_property(this, "savedOnly", false), /**
   * @generated from field: bool alerted_only = 15;
   */ _define_property(this, "alertedOnly", false), /**
   * Filter by scrape source (e.g., "sam.gov", "grants.gov")
   *
   * @generated from field: string source = 16;
   */ _define_property(this, "source", ""), /**
   * Lower bound on response_deadline (RFC3339). Set alongside deadline_before
   * to form a window — e.g. the "Due in N days" chips pass now() here so
   * already-expired postings are excluded from the deadline-filtered results.
   *
   * @generated from field: string deadline_after = 17;
   */ _define_property(this, "deadlineAfter", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunitiesRequest, "runtime", proto3);
_define_property(ListOpportunitiesRequest, "typeName", "mono.morgans.v1.ListOpportunitiesRequest");
_define_property(ListOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "set_aside_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "posted_after",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "deadline_before",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sort_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sort_order",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "active_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "saved_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "alerted_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "deadline_after",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListOpportunitiesResponse
 */ export class ListOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.Opportunity opportunities = 1;
   */ _define_property(this, "opportunities", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 4;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: bool has_more = 5;
   */ _define_property(this, "hasMore", false), /**
   * Computed: ceil(total / limit) for frontend pagination
   *
   * @generated from field: int32 total_pages = 6;
   */ _define_property(this, "totalPages", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunitiesResponse, "runtime", proto3);
_define_property(ListOpportunitiesResponse, "typeName", "mono.morgans.v1.ListOpportunitiesResponse");
_define_property(ListOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: Opportunity,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "has_more",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "total_pages",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityRequest
 */ export class GetOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * Optional user tracking
   *
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityRequest, "runtime", proto3);
_define_property(GetOpportunityRequest, "typeName", "mono.morgans.v1.GetOpportunityRequest");
_define_property(GetOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityResponse
 */ export class GetOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.Opportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityResponse, "runtime", proto3);
_define_property(GetOpportunityResponse, "typeName", "mono.morgans.v1.GetOpportunityResponse");
_define_property(GetOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SearchOpportunitiesRequest
 */ export class SearchOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * @generated from field: int32 top_k = 2;
   */ _define_property(this, "topK", 0), /**
   * @generated from field: float min_score = 3;
   */ _define_property(this, "minScore", 0), /**
   * @generated from field: mono.morgans.v1.SearchFilter filter = 4;
   */ _define_property(this, "filter", void 0), /**
   * Optional user tracking
   *
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchOpportunitiesRequest, "runtime", proto3);
_define_property(SearchOpportunitiesRequest, "typeName", "mono.morgans.v1.SearchOpportunitiesRequest");
_define_property(SearchOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "top_k",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "min_score",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 4,
            name: "filter",
            kind: "message",
            T: SearchFilter
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SearchFilter
 */ export class SearchFilter extends Message {
    static fromBinary(bytes, options) {
        return new SearchFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string department = 1;
   */ _define_property(this, "department", ""), /**
   * @generated from field: string naics_code = 2;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: string type_of_set_aside = 3;
   */ _define_property(this, "typeOfSetAside", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchFilter, "runtime", proto3);
_define_property(SearchFilter, "typeName", "mono.morgans.v1.SearchFilter");
_define_property(SearchFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "department",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type_of_set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SearchOpportunitiesResponse
 */ export class SearchOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.SearchResult results = 1;
   */ _define_property(this, "results", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: string model = 3;
   */ _define_property(this, "model", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchOpportunitiesResponse, "runtime", proto3);
_define_property(SearchOpportunitiesResponse, "typeName", "mono.morgans.v1.SearchOpportunitiesResponse");
_define_property(SearchOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: SearchResult,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SearchResult
 */ export class SearchResult extends Message {
    static fromBinary(bytes, options) {
        return new SearchResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.Opportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0), /**
   * @generated from field: float score = 2;
   */ _define_property(this, "score", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchResult, "runtime", proto3);
_define_property(SearchResult, "typeName", "mono.morgans.v1.SearchResult");
_define_property(SearchResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        },
        {
            no: 2,
            name: "score",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GenerateSummaryRequest
 */ export class GenerateSummaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateSummaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateSummaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateSummaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateSummaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: bool force = 2;
   */ _define_property(this, "force", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateSummaryRequest, "runtime", proto3);
_define_property(GenerateSummaryRequest, "typeName", "mono.morgans.v1.GenerateSummaryRequest");
_define_property(GenerateSummaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "force",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GenerateSummaryResponse
 */ export class GenerateSummaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateSummaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateSummaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateSummaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateSummaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string summary = 2;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: bool was_regenerated = 3;
   */ _define_property(this, "wasRegenerated", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateSummaryResponse, "runtime", proto3);
_define_property(GenerateSummaryResponse, "typeName", "mono.morgans.v1.GenerateSummaryResponse");
_define_property(GenerateSummaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "was_regenerated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.BackfillSummariesRequest
 */ export class BackfillSummariesRequest extends Message {
    static fromBinary(bytes, options) {
        return new BackfillSummariesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BackfillSummariesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BackfillSummariesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BackfillSummariesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Max opportunities to process (default 100)
   *
   * @generated from field: int32 limit = 1;
   */ _define_property(this, "limit", 0), /**
   * Regenerate existing summaries (default false)
   *
   * @generated from field: bool force = 2;
   */ _define_property(this, "force", false), /**
   * Max execution time in milliseconds (default 120000)
   *
   * @generated from field: int32 timeout_ms = 3;
   */ _define_property(this, "timeoutMs", 0), /**
   * If non-empty, restrict backfill to these notice IDs (ignoring `limit`).
   *
   * @generated from field: repeated string notice_ids = 4;
   */ _define_property(this, "noticeIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BackfillSummariesRequest, "runtime", proto3);
_define_property(BackfillSummariesRequest, "typeName", "mono.morgans.v1.BackfillSummariesRequest");
_define_property(BackfillSummariesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "force",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "timeout_ms",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "notice_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.BackfillSummariesResponse
 */ export class BackfillSummariesResponse extends Message {
    static fromBinary(bytes, options) {
        return new BackfillSummariesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BackfillSummariesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BackfillSummariesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BackfillSummariesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Total opportunities attempted
   *
   * @generated from field: int32 processed = 1;
   */ _define_property(this, "processed", 0), /**
   * Successfully generated summaries
   *
   * @generated from field: int32 succeeded = 2;
   */ _define_property(this, "succeeded", 0), /**
   * Failed to generate summaries
   *
   * @generated from field: int32 failed = 3;
   */ _define_property(this, "failed", 0), /**
   * Already had summaries (when force=false)
   *
   * @generated from field: int32 skipped = 4;
   */ _define_property(this, "skipped", 0), /**
   * NoticeIds that timed out and should be retried
   *
   * @generated from field: repeated string queued_ids = 5;
   */ _define_property(this, "queuedIds", []), /**
   * Total execution time
   *
   * @generated from field: int64 elapsed_ms = 6;
   */ _define_property(this, "elapsedMs", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BackfillSummariesResponse, "runtime", proto3);
_define_property(BackfillSummariesResponse, "typeName", "mono.morgans.v1.BackfillSummariesResponse");
_define_property(BackfillSummariesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "processed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "succeeded",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "queued_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "elapsed_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityHistoryRequest
 */ export class GetOpportunityHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string solicitation_number = 2;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityHistoryRequest, "runtime", proto3);
_define_property(GetOpportunityHistoryRequest, "typeName", "mono.morgans.v1.GetOpportunityHistoryRequest");
_define_property(GetOpportunityHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetOpportunityHistoryResponse
 */ export class GetOpportunityHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.OpportunityVersion versions = 1;
   */ _define_property(this, "versions", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * "solicitationNumber" or "title"
   *
   * @generated from field: string strategy = 3;
   */ _define_property(this, "strategy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityHistoryResponse, "runtime", proto3);
_define_property(GetOpportunityHistoryResponse, "typeName", "mono.morgans.v1.GetOpportunityHistoryResponse");
_define_property(GetOpportunityHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: OpportunityVersion,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "strategy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.OpportunityVersion
 */ export class OpportunityVersion extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string solicitation_number = 2;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: int32 amendment_count = 3;
   */ _define_property(this, "amendmentCount", 0), /**
   * @generated from field: google.protobuf.Timestamp modified_date = 4;
   */ _define_property(this, "modifiedDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp posted_date = 5;
   */ _define_property(this, "postedDate", void 0), /**
   * @generated from field: string ui_link = 6;
   */ _define_property(this, "uiLink", ""), /**
   * @generated from field: string parent_opportunity_id = 7;
   */ _define_property(this, "parentOpportunityId", ""), /**
   * @generated from field: int32 current_version = 8;
   */ _define_property(this, "currentVersion", 0), /**
   * @generated from field: string title = 9;
   */ _define_property(this, "title", ""), /**
   * From VersionedOpportunity collection
   *
   * @generated from field: string change_description = 10;
   */ _define_property(this, "changeDescription", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityVersion, "runtime", proto3);
_define_property(OpportunityVersion, "typeName", "mono.morgans.v1.OpportunityVersion");
_define_property(OpportunityVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amendment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "modified_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "posted_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "ui_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "parent_opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "current_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "change_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetSimilarOpportunitiesRequest
 */ export class GetSimilarOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSimilarOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSimilarOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSimilarOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSimilarOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Source opportunity to find similar to
   *
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * Default: 5
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * 0-100, default 0 (Phase 1 only). Controls Phase 2 rollout.
   *
   * @generated from field: int32 ab_test_rollout_percent = 3;
   */ _define_property(this, "abTestRolloutPercent", 0), /**
   * Optional user tracking
   *
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSimilarOpportunitiesRequest, "runtime", proto3);
_define_property(GetSimilarOpportunitiesRequest, "typeName", "mono.morgans.v1.GetSimilarOpportunitiesRequest");
_define_property(GetSimilarOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "ab_test_rollout_percent",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetSimilarOpportunitiesResponse
 */ export class GetSimilarOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSimilarOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSimilarOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSimilarOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSimilarOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.SimilarOpportunity opportunities = 1;
   */ _define_property(this, "opportunities", []), /**
   * "phase1" (NAICS filter) or "phase2" (no NAICS filter)
   *
   * @generated from field: string strategy_used = 2;
   */ _define_property(this, "strategyUsed", ""), /**
   * Before limiting
   *
   * @generated from field: int32 total_candidates = 3;
   */ _define_property(this, "totalCandidates", 0), /**
   * Optional A/B test metrics
   *
   * @generated from field: mono.morgans.v1.SimilarityMetrics metrics = 4;
   */ _define_property(this, "metrics", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSimilarOpportunitiesResponse, "runtime", proto3);
_define_property(GetSimilarOpportunitiesResponse, "typeName", "mono.morgans.v1.GetSimilarOpportunitiesResponse");
_define_property(GetSimilarOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: SimilarOpportunity,
            repeated: true
        },
        {
            no: 2,
            name: "strategy_used",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total_candidates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "metrics",
            kind: "message",
            T: SimilarityMetrics
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SimilarOpportunity
 */ export class SimilarOpportunity extends Message {
    static fromBinary(bytes, options) {
        return new SimilarOpportunity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SimilarOpportunity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SimilarOpportunity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SimilarOpportunity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.Opportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0), /**
   * Semantic similarity (0.0-1.0) or 0.8 (structured fallback)
   *
   * @generated from field: double score = 2;
   */ _define_property(this, "score", 0), /**
   * Amendment/version history
   *
   * @generated from field: repeated mono.morgans.v1.TimelineEntry timeline = 3;
   */ _define_property(this, "timeline", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SimilarOpportunity, "runtime", proto3);
_define_property(SimilarOpportunity, "typeName", "mono.morgans.v1.SimilarOpportunity");
_define_property(SimilarOpportunity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        },
        {
            no: 2,
            name: "score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "timeline",
            kind: "message",
            T: TimelineEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TimelineEntry
 */ export class TimelineEntry extends Message {
    static fromBinary(bytes, options) {
        return new TimelineEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TimelineEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TimelineEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TimelineEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: int32 amendment_count = 2;
   */ _define_property(this, "amendmentCount", 0), /**
   * @generated from field: google.protobuf.Timestamp posted_date = 3;
   */ _define_property(this, "postedDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp modified_date = 4;
   */ _define_property(this, "modifiedDate", void 0), /**
   * @generated from field: string ui_link = 5;
   */ _define_property(this, "uiLink", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TimelineEntry, "runtime", proto3);
_define_property(TimelineEntry, "typeName", "mono.morgans.v1.TimelineEntry");
_define_property(TimelineEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "amendment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "posted_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "modified_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "ui_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SimilarityMetrics
 */ export class SimilarityMetrics extends Message {
    static fromBinary(bytes, options) {
        return new SimilarityMetrics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SimilarityMetrics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SimilarityMetrics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SimilarityMetrics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 result_count = 1;
   */ _define_property(this, "resultCount", 0), /**
   * Unique NAICS / total results
   *
   * @generated from field: double diversity_score = 2;
   */ _define_property(this, "diversityScore", 0), /**
   * @generated from field: double avg_score = 3;
   */ _define_property(this, "avgScore", 0), /**
   * @generated from field: bool has_source_naics_match = 4;
   */ _define_property(this, "hasSourceNaicsMatch", false), /**
   * @generated from field: int64 latency_ms = 5;
   */ _define_property(this, "latencyMs", protoInt64.zero), /**
   * @generated from field: bool used_semantic_search = 6;
   */ _define_property(this, "usedSemanticSearch", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SimilarityMetrics, "runtime", proto3);
_define_property(SimilarityMetrics, "typeName", "mono.morgans.v1.SimilarityMetrics");
_define_property(SimilarityMetrics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "diversity_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "avg_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "has_source_naics_match",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "latency_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "used_semantic_search",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetSavedStatusRequest
 */ export class GetSavedStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSavedStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSavedStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSavedStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSavedStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSavedStatusRequest, "runtime", proto3);
_define_property(GetSavedStatusRequest, "typeName", "mono.morgans.v1.GetSavedStatusRequest");
_define_property(GetSavedStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetSavedStatusResponse
 */ export class GetSavedStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSavedStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSavedStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSavedStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSavedStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool saved = 1;
   */ _define_property(this, "saved", false), /**
   * @generated from field: string notes = 2;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSavedStatusResponse, "runtime", proto3);
_define_property(GetSavedStatusResponse, "typeName", "mono.morgans.v1.GetSavedStatusResponse");
_define_property(GetSavedStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetAlertStatusRequest
 */ export class GetAlertStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAlertStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAlertStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAlertStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAlertStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAlertStatusRequest, "runtime", proto3);
_define_property(GetAlertStatusRequest, "typeName", "mono.morgans.v1.GetAlertStatusRequest");
_define_property(GetAlertStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetAlertStatusResponse
 */ export class GetAlertStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAlertStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAlertStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAlertStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAlertStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool enabled = 1;
   */ _define_property(this, "enabled", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAlertStatusResponse, "runtime", proto3);
_define_property(GetAlertStatusResponse, "typeName", "mono.morgans.v1.GetAlertStatusResponse");
_define_property(GetAlertStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetSavedRequest
 */ export class SetSavedRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetSavedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetSavedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetSavedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetSavedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: bool saved = 4;
   */ _define_property(this, "saved", false), /**
   * @generated from field: string notes = 5;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetSavedRequest, "runtime", proto3);
_define_property(SetSavedRequest, "typeName", "mono.morgans.v1.SetSavedRequest");
_define_property(SetSavedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetSavedResponse
 */ export class SetSavedResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetSavedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetSavedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetSavedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetSavedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool saved = 1;
   */ _define_property(this, "saved", false), /**
   * @generated from field: string notes = 2;
   */ _define_property(this, "notes", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetSavedResponse, "runtime", proto3);
_define_property(SetSavedResponse, "typeName", "mono.morgans.v1.SetSavedResponse");
_define_property(SetSavedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetAlertRequest
 */ export class SetAlertRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetAlertRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetAlertRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetAlertRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetAlertRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string user_email = 2;
   */ _define_property(this, "userEmail", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string notice_id = 4;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: bool enabled = 5;
   */ _define_property(this, "enabled", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetAlertRequest, "runtime", proto3);
_define_property(SetAlertRequest, "typeName", "mono.morgans.v1.SetAlertRequest");
_define_property(SetAlertRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetAlertResponse
 */ export class SetAlertResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetAlertResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetAlertResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetAlertResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetAlertResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool enabled = 1;
   */ _define_property(this, "enabled", false), /**
   * Current count of enabled alerts for user
   *
   * @generated from field: int32 alert_count = 2;
   */ _define_property(this, "alertCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetAlertResponse, "runtime", proto3);
_define_property(SetAlertResponse, "typeName", "mono.morgans.v1.SetAlertResponse");
_define_property(SetAlertResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "alert_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateTrackingProfileRequest
 */ export class CreateTrackingProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateTrackingProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTrackingProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTrackingProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTrackingProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: optional bool is_active = 9;
   */ _define_property(this, "isActive", void 0), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.morgans.v1.TrackingProfileFilters filters = 5;
   */ _define_property(this, "filters", void 0), /**
   * @generated from field: mono.morgans.v1.MatchingConfig matching_config = 6;
   */ _define_property(this, "matchingConfig", void 0), /**
   * @generated from field: mono.morgans.v1.NotificationConfig notifications = 7;
   */ _define_property(this, "notifications", void 0), /**
   * personal (owner only, default) or shared (the owner's tenant).
   *
   * @generated from field: string visibility = 8;
   */ _define_property(this, "visibility", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTrackingProfileRequest, "runtime", proto3);
_define_property(CreateTrackingProfileRequest, "typeName", "mono.morgans.v1.CreateTrackingProfileRequest");
_define_property(CreateTrackingProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 9,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filters",
            kind: "message",
            T: TrackingProfileFilters
        },
        {
            no: 6,
            name: "matching_config",
            kind: "message",
            T: MatchingConfig
        },
        {
            no: 7,
            name: "notifications",
            kind: "message",
            T: NotificationConfig
        },
        {
            no: 8,
            name: "visibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateTrackingProfileResponse
 */ export class CreateTrackingProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateTrackingProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTrackingProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTrackingProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTrackingProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.TrackingProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTrackingProfileResponse, "runtime", proto3);
_define_property(CreateTrackingProfileResponse, "typeName", "mono.morgans.v1.CreateTrackingProfileResponse");
_define_property(CreateTrackingProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: TrackingProfile
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpdateTrackingProfileRequest
 */ export class UpdateTrackingProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateTrackingProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateTrackingProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateTrackingProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateTrackingProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.morgans.v1.TrackingProfileFilters filters = 4;
   */ _define_property(this, "filters", void 0), /**
   * @generated from field: mono.morgans.v1.MatchingConfig matching_config = 5;
   */ _define_property(this, "matchingConfig", void 0), /**
   * @generated from field: mono.morgans.v1.NotificationConfig notifications = 6;
   */ _define_property(this, "notifications", void 0), /**
   * @generated from field: bool is_active = 7;
   */ _define_property(this, "isActive", false), /**
   * Explicit monitoring choice; omission preserves the existing state.
   *
   * @generated from field: optional bool monitoring_enabled = 9;
   */ _define_property(this, "monitoringEnabled", void 0), /**
   * personal or shared; empty leaves the scope unchanged.
   *
   * @generated from field: string visibility = 8;
   */ _define_property(this, "visibility", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateTrackingProfileRequest, "runtime", proto3);
_define_property(UpdateTrackingProfileRequest, "typeName", "mono.morgans.v1.UpdateTrackingProfileRequest");
_define_property(UpdateTrackingProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "filters",
            kind: "message",
            T: TrackingProfileFilters
        },
        {
            no: 5,
            name: "matching_config",
            kind: "message",
            T: MatchingConfig
        },
        {
            no: 6,
            name: "notifications",
            kind: "message",
            T: NotificationConfig
        },
        {
            no: 7,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "monitoring_enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 8,
            name: "visibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpdateTrackingProfileResponse
 */ export class UpdateTrackingProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateTrackingProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateTrackingProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateTrackingProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateTrackingProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.TrackingProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateTrackingProfileResponse, "runtime", proto3);
_define_property(UpdateTrackingProfileResponse, "typeName", "mono.morgans.v1.UpdateTrackingProfileResponse");
_define_property(UpdateTrackingProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: TrackingProfile
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DeleteTrackingProfileRequest
 */ export class DeleteTrackingProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTrackingProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTrackingProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTrackingProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTrackingProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTrackingProfileRequest, "runtime", proto3);
_define_property(DeleteTrackingProfileRequest, "typeName", "mono.morgans.v1.DeleteTrackingProfileRequest");
_define_property(DeleteTrackingProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DeleteTrackingProfileResponse
 */ export class DeleteTrackingProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTrackingProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTrackingProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTrackingProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTrackingProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTrackingProfileResponse, "runtime", proto3);
_define_property(DeleteTrackingProfileResponse, "typeName", "mono.morgans.v1.DeleteTrackingProfileResponse");
_define_property(DeleteTrackingProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListTrackingProfilesRequest
 */ export class ListTrackingProfilesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTrackingProfilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTrackingProfilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTrackingProfilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTrackingProfilesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTrackingProfilesRequest, "runtime", proto3);
_define_property(ListTrackingProfilesRequest, "typeName", "mono.morgans.v1.ListTrackingProfilesRequest");
_define_property(ListTrackingProfilesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListTrackingProfilesResponse
 */ export class ListTrackingProfilesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTrackingProfilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTrackingProfilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTrackingProfilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTrackingProfilesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.TrackingProfile profiles = 1;
   */ _define_property(this, "profiles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTrackingProfilesResponse, "runtime", proto3);
_define_property(ListTrackingProfilesResponse, "typeName", "mono.morgans.v1.ListTrackingProfilesResponse");
_define_property(ListTrackingProfilesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profiles",
            kind: "message",
            T: TrackingProfile,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetTrackingProfileRequest
 */ export class GetTrackingProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetTrackingProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTrackingProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTrackingProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTrackingProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTrackingProfileRequest, "runtime", proto3);
_define_property(GetTrackingProfileRequest, "typeName", "mono.morgans.v1.GetTrackingProfileRequest");
_define_property(GetTrackingProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetTrackingProfileResponse
 */ export class GetTrackingProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetTrackingProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTrackingProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTrackingProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTrackingProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.TrackingProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTrackingProfileResponse, "runtime", proto3);
_define_property(GetTrackingProfileResponse, "typeName", "mono.morgans.v1.GetTrackingProfileResponse");
_define_property(GetTrackingProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: TrackingProfile
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TriggerMatchRequest
 */ export class TriggerMatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new TriggerMatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TriggerMatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TriggerMatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TriggerMatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TriggerMatchRequest, "runtime", proto3);
_define_property(TriggerMatchRequest, "typeName", "mono.morgans.v1.TriggerMatchRequest");
_define_property(TriggerMatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TriggerMatchResponse
 */ export class TriggerMatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new TriggerMatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TriggerMatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TriggerMatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TriggerMatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 profiles_processed = 1;
   */ _define_property(this, "profilesProcessed", 0), /**
   * @generated from field: int32 total_matches = 2;
   */ _define_property(this, "totalMatches", 0), /**
   * @generated from field: int32 new_matches = 3;
   */ _define_property(this, "newMatches", 0), /**
   * @generated from field: int32 duplicate_matches = 4;
   */ _define_property(this, "duplicateMatches", 0), /**
   * @generated from field: repeated mono.morgans.v1.MatchError errors = 5;
   */ _define_property(this, "errors", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TriggerMatchResponse, "runtime", proto3);
_define_property(TriggerMatchResponse, "typeName", "mono.morgans.v1.TriggerMatchResponse");
_define_property(TriggerMatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profiles_processed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "total_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "new_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "duplicate_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "errors",
            kind: "message",
            T: MatchError,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MatchError
 */ export class MatchError extends Message {
    static fromBinary(bytes, options) {
        return new MatchError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchError, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", ""), /**
   * @generated from field: string error = 2;
   */ _define_property(this, "error", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchError, "runtime", proto3);
_define_property(MatchError, "typeName", "mono.morgans.v1.MatchError");
_define_property(MatchError, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.PreviewMatchesRequest
 */ export class PreviewMatchesRequest extends Message {
    static fromBinary(bytes, options) {
        return new PreviewMatchesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewMatchesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewMatchesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewMatchesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: mono.morgans.v1.TrackingProfileFilters filters = 5;
   */ _define_property(this, "filters", void 0), /**
   * @generated from field: mono.morgans.v1.MatchingConfig matching_config = 6;
   */ _define_property(this, "matchingConfig", void 0), /**
   * @generated from field: int32 limit = 7;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewMatchesRequest, "runtime", proto3);
_define_property(PreviewMatchesRequest, "typeName", "mono.morgans.v1.PreviewMatchesRequest");
_define_property(PreviewMatchesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "filters",
            kind: "message",
            T: TrackingProfileFilters
        },
        {
            no: 6,
            name: "matching_config",
            kind: "message",
            T: MatchingConfig
        },
        {
            no: 7,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.PreviewMatchesResponse
 */ export class PreviewMatchesResponse extends Message {
    static fromBinary(bytes, options) {
        return new PreviewMatchesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewMatchesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewMatchesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewMatchesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.PreviewOpportunity opportunities = 1;
   */ _define_property(this, "opportunities", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewMatchesResponse, "runtime", proto3);
_define_property(PreviewMatchesResponse, "typeName", "mono.morgans.v1.PreviewMatchesResponse");
_define_property(PreviewMatchesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: PreviewOpportunity,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.PreviewOpportunity
 */ export class PreviewOpportunity extends Message {
    static fromBinary(bytes, options) {
        return new PreviewOpportunity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewOpportunity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewOpportunity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewOpportunity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string department = 4;
   */ _define_property(this, "department", ""), /**
   * @generated from field: float match_score = 5;
   */ _define_property(this, "matchScore", 0), /**
   * @generated from field: repeated string matched_filters = 6;
   */ _define_property(this, "matchedFilters", []), /**
   * @generated from field: repeated mono.morgans.v1.MatchReason match_reasons = 7;
   */ _define_property(this, "matchReasons", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewOpportunity, "runtime", proto3);
_define_property(PreviewOpportunity, "typeName", "mono.morgans.v1.PreviewOpportunity");
_define_property(PreviewOpportunity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "department",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "match_score",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 6,
            name: "matched_filters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "match_reasons",
            kind: "message",
            T: MatchReason,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetMatchesRequest
 */ export class GetMatchesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", ""), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: string status_filter = 4;
   */ _define_property(this, "statusFilter", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchesRequest, "runtime", proto3);
_define_property(GetMatchesRequest, "typeName", "mono.morgans.v1.GetMatchesRequest");
_define_property(GetMatchesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "status_filter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetMatchesResponse
 */ export class GetMatchesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.ProfileMatch matches = 1;
   */ _define_property(this, "matches", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: bool has_more = 3;
   */ _define_property(this, "hasMore", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchesResponse, "runtime", proto3);
_define_property(GetMatchesResponse, "typeName", "mono.morgans.v1.GetMatchesResponse");
_define_property(GetMatchesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "matches",
            kind: "message",
            T: ProfileMatch,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "has_more",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetMatchStatsRequest
 */ export class GetMatchStatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchStatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchStatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchStatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchStatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string profile_id = 1;
   */ _define_property(this, "profileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchStatsRequest, "runtime", proto3);
_define_property(GetMatchStatsRequest, "typeName", "mono.morgans.v1.GetMatchStatsRequest");
_define_property(GetMatchStatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetMatchStatsResponse
 */ export class GetMatchStatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetMatchStatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMatchStatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMatchStatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMatchStatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_matches = 1;
   */ _define_property(this, "totalMatches", 0), /**
   * @generated from field: int32 new_matches = 2;
   */ _define_property(this, "newMatches", 0), /**
   * @generated from field: int32 viewed_matches = 3;
   */ _define_property(this, "viewedMatches", 0), /**
   * @generated from field: int32 saved_matches = 4;
   */ _define_property(this, "savedMatches", 0), /**
   * @generated from field: int32 dismissed_matches = 5;
   */ _define_property(this, "dismissedMatches", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMatchStatsResponse, "runtime", proto3);
_define_property(GetMatchStatsResponse, "typeName", "mono.morgans.v1.GetMatchStatsResponse");
_define_property(GetMatchStatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "new_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "viewed_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "saved_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "dismissed_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * GetMyMatchStatsRequest names no user: the caller is the gateway principal.
 *
 * @generated from message mono.morgans.v1.GetMyMatchStatsRequest
 */ export class GetMyMatchStatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetMyMatchStatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMyMatchStatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMyMatchStatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMyMatchStatsRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMyMatchStatsRequest, "runtime", proto3);
_define_property(GetMyMatchStatsRequest, "typeName", "mono.morgans.v1.GetMyMatchStatsRequest");
_define_property(GetMyMatchStatsRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.GetMyMatchStatsResponse
 */ export class GetMyMatchStatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetMyMatchStatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMyMatchStatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMyMatchStatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMyMatchStatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * profiles is how many tracking profiles the caller owns in its tenant.
   *
   * @generated from field: int32 profiles = 1;
   */ _define_property(this, "profiles", 0), /**
   * new_matches: their matches neither viewed nor dismissed (unreviewed).
   *
   * @generated from field: int32 new_matches = 2;
   */ _define_property(this, "newMatches", 0), /**
   * older_than_target: of those, matched more than 7 days ago.
   *
   * @generated from field: int32 older_than_target = 3;
   */ _define_property(this, "olderThanTarget", 0), /**
   * oldest_new_days: the oldest unreviewed match's age in days (0 with none).
   *
   * @generated from field: int32 oldest_new_days = 4;
   */ _define_property(this, "oldestNewDays", 0), /**
   * has_value is false with no profile (tone nodata).
   *
   * @generated from field: bool has_value = 5;
   */ _define_property(this, "hasValue", false), /**
   * tone: green (none older than 7 days) | red | nodata.
   *
   * @generated from field: string tone = 6;
   */ _define_property(this, "tone", ""), /**
   * target as shown after "Target: ".
   *
   * @generated from field: string target = 7;
   */ _define_property(this, "target", ""), /**
   * rule is the tooltip; detail what puts it off target ("" when on target).
   *
   * @generated from field: string rule = 8;
   */ _define_property(this, "rule", ""), /**
   * @generated from field: string detail = 9;
   */ _define_property(this, "detail", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMyMatchStatsResponse, "runtime", proto3);
_define_property(GetMyMatchStatsResponse, "typeName", "mono.morgans.v1.GetMyMatchStatsResponse");
_define_property(GetMyMatchStatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profiles",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "new_matches",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "older_than_target",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "oldest_new_days",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "has_value",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "tone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "target",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MarkMatchViewedRequest
 */ export class MarkMatchViewedRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkMatchViewedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkMatchViewedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkMatchViewedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkMatchViewedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string match_id = 1;
   */ _define_property(this, "matchId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkMatchViewedRequest, "runtime", proto3);
_define_property(MarkMatchViewedRequest, "typeName", "mono.morgans.v1.MarkMatchViewedRequest");
_define_property(MarkMatchViewedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "match_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MarkMatchViewedResponse
 */ export class MarkMatchViewedResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkMatchViewedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkMatchViewedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkMatchViewedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkMatchViewedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkMatchViewedResponse, "runtime", proto3);
_define_property(MarkMatchViewedResponse, "typeName", "mono.morgans.v1.MarkMatchViewedResponse");
_define_property(MarkMatchViewedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DismissMatchRequest
 */ export class DismissMatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new DismissMatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DismissMatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DismissMatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DismissMatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string match_id = 1;
   */ _define_property(this, "matchId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DismissMatchRequest, "runtime", proto3);
_define_property(DismissMatchRequest, "typeName", "mono.morgans.v1.DismissMatchRequest");
_define_property(DismissMatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "match_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DismissMatchResponse
 */ export class DismissMatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new DismissMatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DismissMatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DismissMatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DismissMatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DismissMatchResponse, "runtime", proto3);
_define_property(DismissMatchResponse, "typeName", "mono.morgans.v1.DismissMatchResponse");
_define_property(DismissMatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SaveMatchRequest
 */ export class SaveMatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveMatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveMatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveMatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveMatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string match_id = 1;
   */ _define_property(this, "matchId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveMatchRequest, "runtime", proto3);
_define_property(SaveMatchRequest, "typeName", "mono.morgans.v1.SaveMatchRequest");
_define_property(SaveMatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "match_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SaveMatchResponse
 */ export class SaveMatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveMatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveMatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveMatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveMatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveMatchResponse, "runtime", proto3);
_define_property(SaveMatchResponse, "typeName", "mono.morgans.v1.SaveMatchResponse");
_define_property(SaveMatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetHealthRequest
 */ export class GetHealthRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetHealthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetHealthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetHealthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetHealthRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetHealthRequest, "runtime", proto3);
_define_property(GetHealthRequest, "typeName", "mono.morgans.v1.GetHealthRequest");
_define_property(GetHealthRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.GetHealthResponse
 */ export class GetHealthResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetHealthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetHealthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetHealthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetHealthResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool healthy = 1;
   */ _define_property(this, "healthy", false), /**
   * @generated from field: string database_status = 2;
   */ _define_property(this, "databaseStatus", ""), /**
   * @generated from field: string qdrant_status = 3;
   */ _define_property(this, "qdrantStatus", ""), /**
   * @generated from field: string scraper_status = 4;
   */ _define_property(this, "scraperStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp last_scrape = 5;
   */ _define_property(this, "lastScrape", void 0), /**
   * @generated from field: int32 opportunity_count = 6;
   */ _define_property(this, "opportunityCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetHealthResponse, "runtime", proto3);
_define_property(GetHealthResponse, "typeName", "mono.morgans.v1.GetHealthResponse");
_define_property(GetHealthResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "healthy",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "database_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "qdrant_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scraper_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "last_scrape",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "opportunity_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.Opportunity
 */ export class Opportunity extends Message {
    static fromBinary(bytes, options) {
        return new Opportunity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Opportunity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Opportunity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Opportunity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string solicitation_number = 3;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string department = 6;
   */ _define_property(this, "department", ""), /**
   * @generated from field: string sub_tier = 7;
   */ _define_property(this, "subTier", ""), /**
   * @generated from field: string office = 8;
   */ _define_property(this, "office", ""), /**
   * @generated from field: string full_agency_hierarchy = 9;
   */ _define_property(this, "fullAgencyHierarchy", ""), /**
   * @generated from field: google.protobuf.Timestamp posted_date = 10;
   */ _define_property(this, "postedDate", void 0), /**
   * @generated from field: string type = 11;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string base_type = 12;
   */ _define_property(this, "baseType", ""), /**
   * @generated from field: string type_of_set_aside_description = 13;
   */ _define_property(this, "typeOfSetAsideDescription", ""), /**
   * @generated from field: string type_of_set_aside = 14;
   */ _define_property(this, "typeOfSetAside", ""), /**
   * @generated from field: google.protobuf.Timestamp response_deadline = 15;
   */ _define_property(this, "responseDeadline", void 0), /**
   * @generated from field: string naics_code = 16;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: repeated string naics_codes = 17;
   */ _define_property(this, "naicsCodes", []), /**
   * @generated from field: string classification_code = 18;
   */ _define_property(this, "classificationCode", ""), /**
   * @generated from field: bool active = 19;
   */ _define_property(this, "active", false), /**
   * @generated from field: string ui_link = 20;
   */ _define_property(this, "uiLink", ""), /**
   * @generated from field: string additional_info_link = 21;
   */ _define_property(this, "additionalInfoLink", ""), /**
   * @generated from field: repeated mono.morgans.v1.Contact contacts = 22;
   */ _define_property(this, "contacts", []), /**
   * @generated from field: mono.morgans.v1.Address office_address = 23;
   */ _define_property(this, "officeAddress", void 0), /**
   * @generated from field: mono.morgans.v1.Address place_of_performance = 24;
   */ _define_property(this, "placeOfPerformance", void 0), /**
   * @generated from field: mono.morgans.v1.Award award = 25;
   */ _define_property(this, "award", void 0), /**
   * @generated from field: bool has_attachments = 26;
   */ _define_property(this, "hasAttachments", false), /**
   * @generated from field: int32 attachment_count = 27;
   */ _define_property(this, "attachmentCount", 0), /**
   * @generated from field: string summary = 28;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: google.protobuf.Timestamp summary_generated_at = 29;
   */ _define_property(this, "summaryGeneratedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp last_scraped_at = 30;
   */ _define_property(this, "lastScrapedAt", void 0), /**
   * @generated from field: int32 amendment_count = 31;
   */ _define_property(this, "amendmentCount", 0), /**
   * User tracking (MongoDB-backed, populated when user_id provided)
   *
   * @generated from field: bool is_saved = 32;
   */ _define_property(this, "isSaved", false), /**
   * @generated from field: string saved_notes = 33;
   */ _define_property(this, "savedNotes", ""), /**
   * @generated from field: bool is_alerted = 34;
   */ _define_property(this, "isAlerted", false), /**
   * All versions from MongoDB (list view only)
   *
   * @generated from field: repeated mono.morgans.v1.OpportunityVersion versions = 35;
   */ _define_property(this, "versions", []), /**
   * @generated from field: int32 version_count = 36;
   */ _define_property(this, "versionCount", 0), /**
   * URL to full description on SAM.gov
   *
   * @generated from field: string description_link = 37;
   */ _define_property(this, "descriptionLink", ""), /**
   * Source of the opportunity data (e.g., "sam.gov", "grants.gov")
   *
   * @generated from field: string scrape_source = 38;
   */ _define_property(this, "scrapeSource", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Opportunity, "runtime", proto3);
_define_property(Opportunity, "typeName", "mono.morgans.v1.Opportunity");
_define_property(Opportunity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "department",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sub_tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "office",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "full_agency_hierarchy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "posted_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "base_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "type_of_set_aside_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "type_of_set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "response_deadline",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "naics_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 18,
            name: "classification_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 20,
            name: "ui_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "additional_info_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "contacts",
            kind: "message",
            T: Contact,
            repeated: true
        },
        {
            no: 23,
            name: "office_address",
            kind: "message",
            T: Address
        },
        {
            no: 24,
            name: "place_of_performance",
            kind: "message",
            T: Address
        },
        {
            no: 25,
            name: "award",
            kind: "message",
            T: Award
        },
        {
            no: 26,
            name: "has_attachments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 27,
            name: "attachment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 28,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "summary_generated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 30,
            name: "last_scraped_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 31,
            name: "amendment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 32,
            name: "is_saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 33,
            name: "saved_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "is_alerted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 35,
            name: "versions",
            kind: "message",
            T: OpportunityVersion,
            repeated: true
        },
        {
            no: 36,
            name: "version_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 37,
            name: "description_link",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "scrape_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.Contact
 */ export class Contact extends Message {
    static fromBinary(bytes, options) {
        return new Contact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Contact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Contact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Contact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string type = 1;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string full_name = 2;
   */ _define_property(this, "fullName", ""), /**
   * @generated from field: string email = 3;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 4;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Contact, "runtime", proto3);
_define_property(Contact, "typeName", "mono.morgans.v1.Contact");
_define_property(Contact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "full_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.Address
 */ export class Address extends Message {
    static fromBinary(bytes, options) {
        return new Address().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Address().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Address().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Address, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string street = 1;
   */ _define_property(this, "street", ""), /**
   * @generated from field: string city = 2;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip = 4;
   */ _define_property(this, "zip", ""), /**
   * @generated from field: string country_code = 5;
   */ _define_property(this, "countryCode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Address, "runtime", proto3);
_define_property(Address, "typeName", "mono.morgans.v1.Address");
_define_property(Address, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "street",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "zip",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "country_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.Award
 */ export class Award extends Message {
    static fromBinary(bytes, options) {
        return new Award().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Award().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Award().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Award, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string number = 1;
   */ _define_property(this, "number", ""), /**
   * @generated from field: string date = 2;
   */ _define_property(this, "date", ""), /**
   * @generated from field: string amount = 3;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: string awardee_name = 4;
   */ _define_property(this, "awardeeName", ""), /**
   * @generated from field: string awardee_uei = 5;
   */ _define_property(this, "awardeeUei", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Award, "runtime", proto3);
_define_property(Award, "typeName", "mono.morgans.v1.Award");
_define_property(Award, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "awardee_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "awardee_uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TrackingProfile
 */ export class TrackingProfile extends Message {
    static fromBinary(bytes, options) {
        return new TrackingProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TrackingProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TrackingProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TrackingProfile, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string embedding_status = 6;
   */ _define_property(this, "embeddingStatus", ""), /**
   * @generated from field: mono.morgans.v1.TrackingProfileFilters filters = 7;
   */ _define_property(this, "filters", void 0), /**
   * @generated from field: mono.morgans.v1.MatchingConfig matching_config = 8;
   */ _define_property(this, "matchingConfig", void 0), /**
   * @generated from field: mono.morgans.v1.NotificationConfig notifications = 9;
   */ _define_property(this, "notifications", void 0), /**
   * @generated from field: bool is_active = 10;
   */ _define_property(this, "isActive", false), /**
   * @generated from field: google.protobuf.Timestamp last_matched_at = 11;
   */ _define_property(this, "lastMatchedAt", void 0), /**
   * @generated from field: int32 match_count = 12;
   */ _define_property(this, "matchCount", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */ _define_property(this, "updatedAt", void 0), /**
   * personal (owner only) or shared (the owner's tenant).
   *
   * @generated from field: string visibility = 15;
   */ _define_property(this, "visibility", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TrackingProfile, "runtime", proto3);
_define_property(TrackingProfile, "typeName", "mono.morgans.v1.TrackingProfile");
_define_property(TrackingProfile, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "embedding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "filters",
            kind: "message",
            T: TrackingProfileFilters
        },
        {
            no: 8,
            name: "matching_config",
            kind: "message",
            T: MatchingConfig
        },
        {
            no: 9,
            name: "notifications",
            kind: "message",
            T: NotificationConfig
        },
        {
            no: 10,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "last_matched_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "match_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "visibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.TrackingProfileFilters
 */ export class TrackingProfileFilters extends Message {
    static fromBinary(bytes, options) {
        return new TrackingProfileFilters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TrackingProfileFilters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TrackingProfileFilters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TrackingProfileFilters, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string naics_codes = 1;
   */ _define_property(this, "naicsCodes", []), /**
   * @generated from field: repeated string psc_codes = 2;
   */ _define_property(this, "pscCodes", []), /**
   * @generated from field: repeated string set_aside_codes = 3;
   */ _define_property(this, "setAsideCodes", []), /**
   * @generated from field: repeated string agencies = 4;
   */ _define_property(this, "agencies", []), /**
   * @generated from field: repeated string states = 5;
   */ _define_property(this, "states", []), /**
   * @generated from field: double min_value = 6;
   */ _define_property(this, "minValue", 0), /**
   * @generated from field: double max_value = 7;
   */ _define_property(this, "maxValue", 0), /**
   * @generated from field: repeated string keywords = 8;
   */ _define_property(this, "keywords", []), /**
   * @generated from field: repeated string exclude_keywords = 9;
   */ _define_property(this, "excludeKeywords", []), /**
   * @generated from field: repeated string notice_types = 10;
   */ _define_property(this, "noticeTypes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TrackingProfileFilters, "runtime", proto3);
_define_property(TrackingProfileFilters, "typeName", "mono.morgans.v1.TrackingProfileFilters");
_define_property(TrackingProfileFilters, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "naics_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "psc_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "set_aside_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "agencies",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "states",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "min_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "max_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "keywords",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "exclude_keywords",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "notice_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MatchingConfig
 */ export class MatchingConfig extends Message {
    static fromBinary(bytes, options) {
        return new MatchingConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchingConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchingConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchingConfig, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double semantic_threshold = 1;
   */ _define_property(this, "semanticThreshold", 0), /**
   * @generated from field: bool require_all_filters = 2;
   */ _define_property(this, "requireAllFilters", false), /**
   * @generated from field: bool include_expired_opportunities = 3;
   */ _define_property(this, "includeExpiredOpportunities", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchingConfig, "runtime", proto3);
_define_property(MatchingConfig, "typeName", "mono.morgans.v1.MatchingConfig");
_define_property(MatchingConfig, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "semantic_threshold",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "require_all_filters",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "include_expired_opportunities",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.NotificationConfig
 */ export class NotificationConfig extends Message {
    static fromBinary(bytes, options) {
        return new NotificationConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationConfig, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool enabled = 1;
   */ _define_property(this, "enabled", false), /**
   * @generated from field: string frequency = 2;
   */ _define_property(this, "frequency", ""), /**
   * @generated from field: repeated string email_addresses = 3;
   */ _define_property(this, "emailAddresses", []), /**
   * @generated from field: bool include_in_digest = 4;
   */ _define_property(this, "includeInDigest", false), /**
   * @generated from field: double min_match_score = 5;
   */ _define_property(this, "minMatchScore", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationConfig, "runtime", proto3);
_define_property(NotificationConfig, "typeName", "mono.morgans.v1.NotificationConfig");
_define_property(NotificationConfig, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "email_addresses",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "include_in_digest",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "min_match_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ProfileMatch
 */ export class ProfileMatch extends Message {
    static fromBinary(bytes, options) {
        return new ProfileMatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProfileMatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProfileMatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProfileMatch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string profile_id = 2;
   */ _define_property(this, "profileId", ""), /**
   * @generated from field: string opportunity_notice_id = 3;
   */ _define_property(this, "opportunityNoticeId", ""), /**
   * @generated from field: string source = 4;
   */ _define_property(this, "source", ""), /**
   * @generated from field: float match_score = 5;
   */ _define_property(this, "matchScore", 0), /**
   * @generated from field: repeated string matched_filters = 6;
   */ _define_property(this, "matchedFilters", []), /**
   * @generated from field: google.protobuf.Timestamp matched_at = 7;
   */ _define_property(this, "matchedAt", void 0), /**
   * @generated from field: bool notification_sent = 8;
   */ _define_property(this, "notificationSent", false), /**
   * @generated from field: bool viewed = 9;
   */ _define_property(this, "viewed", false), /**
   * @generated from field: google.protobuf.Timestamp viewed_at = 10;
   */ _define_property(this, "viewedAt", void 0), /**
   * @generated from field: bool dismissed = 11;
   */ _define_property(this, "dismissed", false), /**
   * @generated from field: bool saved = 12;
   */ _define_property(this, "saved", false), /**
   * @generated from field: mono.morgans.v1.Opportunity opportunity = 13;
   */ _define_property(this, "opportunity", void 0), /**
   * @generated from field: repeated mono.morgans.v1.MatchReason match_reasons = 14;
   */ _define_property(this, "matchReasons", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProfileMatch, "runtime", proto3);
_define_property(ProfileMatch, "typeName", "mono.morgans.v1.ProfileMatch");
_define_property(ProfileMatch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "match_score",
            kind: "scalar",
            T: 2 /* ScalarType.FLOAT */ 
        },
        {
            no: 6,
            name: "matched_filters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "matched_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "notification_sent",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "viewed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "viewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "dismissed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "saved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        },
        {
            no: 14,
            name: "match_reasons",
            kind: "message",
            T: MatchReason,
            repeated: true
        }
    ]));
/**
 * One configured criterion of a Tracking Profile and whether the notice met it.
 *
 * @generated from message mono.morgans.v1.MatchReason
 */ export class MatchReason extends Message {
    static fromBinary(bytes, options) {
        return new MatchReason().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchReason().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchReason().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchReason, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string criterion = 1;
   */ _define_property(this, "criterion", ""), /**
   * @generated from field: string value = 2;
   */ _define_property(this, "value", ""), /**
   * @generated from field: bool matched = 3;
   */ _define_property(this, "matched", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchReason, "runtime", proto3);
_define_property(MatchReason, "typeName", "mono.morgans.v1.MatchReason");
_define_property(MatchReason, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "criterion",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "matched",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CanonicalOpportunity
 */ export class CanonicalOpportunity extends Message {
    static fromBinary(bytes, options) {
        return new CanonicalOpportunity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CanonicalOpportunity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CanonicalOpportunity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CanonicalOpportunity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string created_by = 3;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CanonicalOpportunity, "runtime", proto3);
_define_property(CanonicalOpportunity, "typeName", "mono.morgans.v1.CanonicalOpportunity");
_define_property(CanonicalOpportunity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CanonicalOpportunityNoticeLink
 */ export class CanonicalOpportunityNoticeLink extends Message {
    static fromBinary(bytes, options) {
        return new CanonicalOpportunityNoticeLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CanonicalOpportunityNoticeLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CanonicalOpportunityNoticeLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CanonicalOpportunityNoticeLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string created_by = 4;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CanonicalOpportunityNoticeLink, "runtime", proto3);
_define_property(CanonicalOpportunityNoticeLink, "typeName", "mono.morgans.v1.CanonicalOpportunityNoticeLink");
_define_property(CanonicalOpportunityNoticeLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateCanonicalOpportunityRequest
 */ export class CreateCanonicalOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCanonicalOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCanonicalOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCanonicalOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCanonicalOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCanonicalOpportunityRequest, "runtime", proto3);
_define_property(CreateCanonicalOpportunityRequest, "typeName", "mono.morgans.v1.CreateCanonicalOpportunityRequest");
_define_property(CreateCanonicalOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateCanonicalOpportunityResponse
 */ export class CreateCanonicalOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCanonicalOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCanonicalOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCanonicalOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCanonicalOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.CanonicalOpportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCanonicalOpportunityResponse, "runtime", proto3);
_define_property(CreateCanonicalOpportunityResponse, "typeName", "mono.morgans.v1.CreateCanonicalOpportunityResponse");
_define_property(CreateCanonicalOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: CanonicalOpportunity
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetCanonicalOpportunityRequest
 */ export class GetCanonicalOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCanonicalOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCanonicalOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCanonicalOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCanonicalOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCanonicalOpportunityRequest, "runtime", proto3);
_define_property(GetCanonicalOpportunityRequest, "typeName", "mono.morgans.v1.GetCanonicalOpportunityRequest");
_define_property(GetCanonicalOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetCanonicalOpportunityResponse
 */ export class GetCanonicalOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCanonicalOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCanonicalOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCanonicalOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCanonicalOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.CanonicalOpportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCanonicalOpportunityResponse, "runtime", proto3);
_define_property(GetCanonicalOpportunityResponse, "typeName", "mono.morgans.v1.GetCanonicalOpportunityResponse");
_define_property(GetCanonicalOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: CanonicalOpportunity
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListCanonicalOpportunitiesRequest
 */ export class ListCanonicalOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCanonicalOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCanonicalOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCanonicalOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCanonicalOpportunitiesRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCanonicalOpportunitiesRequest, "runtime", proto3);
_define_property(ListCanonicalOpportunitiesRequest, "typeName", "mono.morgans.v1.ListCanonicalOpportunitiesRequest");
_define_property(ListCanonicalOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.ListCanonicalOpportunitiesResponse
 */ export class ListCanonicalOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCanonicalOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCanonicalOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCanonicalOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCanonicalOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.CanonicalOpportunity opportunities = 1;
   */ _define_property(this, "opportunities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCanonicalOpportunitiesResponse, "runtime", proto3);
_define_property(ListCanonicalOpportunitiesResponse, "typeName", "mono.morgans.v1.ListCanonicalOpportunitiesResponse");
_define_property(ListCanonicalOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: CanonicalOpportunity,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.LinkCanonicalOpportunityNoticeRequest
 */ export class LinkCanonicalOpportunityNoticeRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkCanonicalOpportunityNoticeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkCanonicalOpportunityNoticeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkCanonicalOpportunityNoticeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkCanonicalOpportunityNoticeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkCanonicalOpportunityNoticeRequest, "runtime", proto3);
_define_property(LinkCanonicalOpportunityNoticeRequest, "typeName", "mono.morgans.v1.LinkCanonicalOpportunityNoticeRequest");
_define_property(LinkCanonicalOpportunityNoticeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.LinkCanonicalOpportunityNoticeResponse
 */ export class LinkCanonicalOpportunityNoticeResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkCanonicalOpportunityNoticeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkCanonicalOpportunityNoticeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkCanonicalOpportunityNoticeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkCanonicalOpportunityNoticeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.CanonicalOpportunityNoticeLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkCanonicalOpportunityNoticeResponse, "runtime", proto3);
_define_property(LinkCanonicalOpportunityNoticeResponse, "typeName", "mono.morgans.v1.LinkCanonicalOpportunityNoticeResponse");
_define_property(LinkCanonicalOpportunityNoticeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CanonicalOpportunityNoticeLink
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UnlinkCanonicalOpportunityNoticeRequest
 */ export class UnlinkCanonicalOpportunityNoticeRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkCanonicalOpportunityNoticeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkCanonicalOpportunityNoticeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkCanonicalOpportunityNoticeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkCanonicalOpportunityNoticeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkCanonicalOpportunityNoticeRequest, "runtime", proto3);
_define_property(UnlinkCanonicalOpportunityNoticeRequest, "typeName", "mono.morgans.v1.UnlinkCanonicalOpportunityNoticeRequest");
_define_property(UnlinkCanonicalOpportunityNoticeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UnlinkCanonicalOpportunityNoticeResponse
 */ export class UnlinkCanonicalOpportunityNoticeResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkCanonicalOpportunityNoticeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkCanonicalOpportunityNoticeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkCanonicalOpportunityNoticeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkCanonicalOpportunityNoticeResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkCanonicalOpportunityNoticeResponse, "runtime", proto3);
_define_property(UnlinkCanonicalOpportunityNoticeResponse, "typeName", "mono.morgans.v1.UnlinkCanonicalOpportunityNoticeResponse");
_define_property(UnlinkCanonicalOpportunityNoticeResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.ListCanonicalOpportunityNoticeLinksRequest
 */ export class ListCanonicalOpportunityNoticeLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCanonicalOpportunityNoticeLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCanonicalOpportunityNoticeLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCanonicalOpportunityNoticeLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCanonicalOpportunityNoticeLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCanonicalOpportunityNoticeLinksRequest, "runtime", proto3);
_define_property(ListCanonicalOpportunityNoticeLinksRequest, "typeName", "mono.morgans.v1.ListCanonicalOpportunityNoticeLinksRequest");
_define_property(ListCanonicalOpportunityNoticeLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListCanonicalOpportunityNoticeLinksResponse
 */ export class ListCanonicalOpportunityNoticeLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCanonicalOpportunityNoticeLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCanonicalOpportunityNoticeLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCanonicalOpportunityNoticeLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCanonicalOpportunityNoticeLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.CanonicalOpportunityNoticeLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCanonicalOpportunityNoticeLinksResponse, "runtime", proto3);
_define_property(ListCanonicalOpportunityNoticeLinksResponse, "typeName", "mono.morgans.v1.ListCanonicalOpportunityNoticeLinksResponse");
_define_property(ListCanonicalOpportunityNoticeLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: CanonicalOpportunityNoticeLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.NoticePublication
 */ export class NoticePublication extends Message {
    static fromBinary(bytes, options) {
        return new NoticePublication().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoticePublication().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoticePublication().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoticePublication, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string root_notice_id = 3;
   */ _define_property(this, "rootNoticeId", ""), /**
   * @generated from field: int32 version = 4;
   */ _define_property(this, "version", 0), /**
   * original | amendment
   *
   * @generated from field: string publication_type = 5;
   */ _define_property(this, "publicationType", ""), /**
   * @generated from field: string source = 6;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_identifier = 7;
   */ _define_property(this, "sourceIdentifier", ""), /**
   * @generated from field: string title = 8;
   */ _define_property(this, "title", ""), /**
   * not_required | pending_review | reviewed
   *
   * @generated from field: string review_status = 9;
   */ _define_property(this, "reviewStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 10;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: string created_by = 11;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * sam_ingest | manual
   *
   * @generated from field: string origin = 13;
   */ _define_property(this, "origin", ""), /**
   * who/where manual intel was received
   *
   * @generated from field: string provenance = 14;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: string reviewed_by = 15;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 16;
   */ _define_property(this, "reviewedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NoticePublication, "runtime", proto3);
_define_property(NoticePublication, "typeName", "mono.morgans.v1.NoticePublication");
_define_property(NoticePublication, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "root_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "publication_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "review_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RecordNoticePublicationRequest
 */ export class RecordNoticePublicationRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordNoticePublicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordNoticePublicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordNoticePublicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordNoticePublicationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * empty records the original
   *
   * @generated from field: string parent_notice_id = 2;
   */ _define_property(this, "parentNoticeId", ""), /**
   * @generated from field: string source = 3;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_identifier = 4;
   */ _define_property(this, "sourceIdentifier", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * sam_ingest (default) | manual
   *
   * @generated from field: string origin = 6;
   */ _define_property(this, "origin", ""), /**
   * @generated from field: string provenance = 7;
   */ _define_property(this, "provenance", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordNoticePublicationRequest, "runtime", proto3);
_define_property(RecordNoticePublicationRequest, "typeName", "mono.morgans.v1.RecordNoticePublicationRequest");
_define_property(RecordNoticePublicationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RecordNoticePublicationResponse
 */ export class RecordNoticePublicationResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordNoticePublicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordNoticePublicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordNoticePublicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordNoticePublicationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.NoticePublication publication = 1;
   */ _define_property(this, "publication", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordNoticePublicationResponse, "runtime", proto3);
_define_property(RecordNoticePublicationResponse, "typeName", "mono.morgans.v1.RecordNoticePublicationResponse");
_define_property(RecordNoticePublicationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication",
            kind: "message",
            T: NoticePublication
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListNoticePublicationsRequest
 */ export class ListNoticePublicationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticePublicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticePublicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticePublicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticePublicationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticePublicationsRequest, "runtime", proto3);
_define_property(ListNoticePublicationsRequest, "typeName", "mono.morgans.v1.ListNoticePublicationsRequest");
_define_property(ListNoticePublicationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListNoticePublicationsResponse
 */ export class ListNoticePublicationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticePublicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticePublicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticePublicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticePublicationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.NoticePublication publications = 1;
   */ _define_property(this, "publications", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticePublicationsResponse, "runtime", proto3);
_define_property(ListNoticePublicationsResponse, "typeName", "mono.morgans.v1.ListNoticePublicationsResponse");
_define_property(ListNoticePublicationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publications",
            kind: "message",
            T: NoticePublication,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RecordManualIntelRequest
 */ export class RecordManualIntelRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordManualIntelRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordManualIntelRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordManualIntelRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordManualIntelRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", ""), /**
   * empty records the original
   *
   * @generated from field: string parent_notice_id = 3;
   */ _define_property(this, "parentNoticeId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * required: who/where the intel came from
   *
   * @generated from field: string provenance = 5;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: repeated string materials_obtained = 6;
   */ _define_property(this, "materialsObtained", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordManualIntelRequest, "runtime", proto3);
_define_property(RecordManualIntelRequest, "typeName", "mono.morgans.v1.RecordManualIntelRequest");
_define_property(RecordManualIntelRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parent_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "materials_obtained",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RecordManualIntelResponse
 */ export class RecordManualIntelResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordManualIntelResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordManualIntelResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordManualIntelResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordManualIntelResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.NoticePublication publication = 1;
   */ _define_property(this, "publication", void 0), /**
   * @generated from field: mono.morgans.v1.NoticeSourceCoverage coverage = 2;
   */ _define_property(this, "coverage", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordManualIntelResponse, "runtime", proto3);
_define_property(RecordManualIntelResponse, "typeName", "mono.morgans.v1.RecordManualIntelResponse");
_define_property(RecordManualIntelResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication",
            kind: "message",
            T: NoticePublication
        },
        {
            no: 2,
            name: "coverage",
            kind: "message",
            T: NoticeSourceCoverage
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ReviewNoticePublicationRequest
 */ export class ReviewNoticePublicationRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewNoticePublicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewNoticePublicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewNoticePublicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewNoticePublicationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string publication_id = 1;
   */ _define_property(this, "publicationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewNoticePublicationRequest, "runtime", proto3);
_define_property(ReviewNoticePublicationRequest, "typeName", "mono.morgans.v1.ReviewNoticePublicationRequest");
_define_property(ReviewNoticePublicationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ReviewNoticePublicationResponse
 */ export class ReviewNoticePublicationResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewNoticePublicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewNoticePublicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewNoticePublicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewNoticePublicationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.NoticePublication publication = 1;
   */ _define_property(this, "publication", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewNoticePublicationResponse, "runtime", proto3);
_define_property(ReviewNoticePublicationResponse, "typeName", "mono.morgans.v1.ReviewNoticePublicationResponse");
_define_property(ReviewNoticePublicationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication",
            kind: "message",
            T: NoticePublication
        }
    ]));
/**
 * @generated from message mono.morgans.v1.NoticeSourceCoverage
 */ export class NoticeSourceCoverage extends Message {
    static fromBinary(bytes, options) {
        return new NoticeSourceCoverage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoticeSourceCoverage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoticeSourceCoverage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoticeSourceCoverage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * sam_gov | manual
   *
   * @generated from field: string source = 3;
   */ _define_property(this, "source", ""), /**
   * unknown | unavailable | failed | stale | no_results | partial | current
   *
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string source_identifier = 5;
   */ _define_property(this, "sourceIdentifier", ""), /**
   * unset when never retrieved
   *
   * @generated from field: google.protobuf.Timestamp retrieved_at = 6;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: repeated string materials_obtained = 7;
   */ _define_property(this, "materialsObtained", []), /**
   * @generated from field: string detail = 8;
   */ _define_property(this, "detail", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NoticeSourceCoverage, "runtime", proto3);
_define_property(NoticeSourceCoverage, "typeName", "mono.morgans.v1.NoticeSourceCoverage");
_define_property(NoticeSourceCoverage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "materials_obtained",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListNoticeSourceCoverageRequest
 */ export class ListNoticeSourceCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticeSourceCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticeSourceCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticeSourceCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticeSourceCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticeSourceCoverageRequest, "runtime", proto3);
_define_property(ListNoticeSourceCoverageRequest, "typeName", "mono.morgans.v1.ListNoticeSourceCoverageRequest");
_define_property(ListNoticeSourceCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListNoticeSourceCoverageResponse
 */ export class ListNoticeSourceCoverageResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticeSourceCoverageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticeSourceCoverageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticeSourceCoverageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticeSourceCoverageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.NoticeSourceCoverage coverage = 1;
   */ _define_property(this, "coverage", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticeSourceCoverageResponse, "runtime", proto3);
_define_property(ListNoticeSourceCoverageResponse, "typeName", "mono.morgans.v1.ListNoticeSourceCoverageResponse");
_define_property(ListNoticeSourceCoverageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "coverage",
            kind: "message",
            T: NoticeSourceCoverage,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.LandscapeCriterionInput
 */ export class LandscapeCriterionInput extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeCriterionInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeCriterionInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeCriterionInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeCriterionInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.LandscapeCriterionKind kind = 1;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string value = 2;
   */ _define_property(this, "value", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeCriterionInput, "runtime", proto3);
_define_property(LandscapeCriterionInput, "typeName", "mono.morgans.v1.LandscapeCriterionInput");
_define_property(LandscapeCriterionInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(LandscapeCriterionKind)
        },
        {
            no: 2,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.LandscapeCriterion
 */ export class LandscapeCriterion extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeCriterion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeCriterion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeCriterion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeCriterion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.morgans.v1.LandscapeCriterionKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string value = 3;
   */ _define_property(this, "value", ""), /**
   * @generated from field: string fingerprint = 4;
   */ _define_property(this, "fingerprint", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeCriterion, "runtime", proto3);
_define_property(LandscapeCriterion, "typeName", "mono.morgans.v1.LandscapeCriterion");
_define_property(LandscapeCriterion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(LandscapeCriterionKind)
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.morgans.v1.Landscape
 */ export class Landscape extends Message {
    static fromBinary(bytes, options) {
        return new Landscape().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Landscape().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Landscape().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Landscape, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string scope = 3;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: repeated string organization_ids = 4;
   */ _define_property(this, "organizationIds", []), /**
   * @generated from field: repeated string capabilities = 5;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: string context = 6;
   */ _define_property(this, "context", ""), /**
   * @generated from field: bool observed_only = 7;
   */ _define_property(this, "observedOnly", false), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: repeated mono.morgans.v1.LandscapeCriterion criteria = 11;
   */ _define_property(this, "criteria", []), /**
   * Zero when the caller lacks "opportunity" read.
   *
   * @generated from field: int32 active_member_count = 12;
   */ _define_property(this, "activeMemberCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Landscape, "runtime", proto3);
_define_property(Landscape, "typeName", "mono.morgans.v1.Landscape");
_define_property(Landscape, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "organization_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "capabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "observed_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "criteria",
            kind: "message",
            T: LandscapeCriterion,
            repeated: true
        },
        {
            no: 12,
            name: "active_member_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateLandscapeRequest
 */ export class CreateLandscapeRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateLandscapeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLandscapeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLandscapeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLandscapeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string scope = 2;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: repeated string organization_ids = 3;
   */ _define_property(this, "organizationIds", []), /**
   * @generated from field: repeated string capabilities = 4;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: string context = 5;
   */ _define_property(this, "context", ""), /**
   * @generated from field: bool observed_only = 6;
   */ _define_property(this, "observedOnly", false), /**
   * @generated from field: repeated mono.morgans.v1.LandscapeCriterionInput criteria = 7;
   */ _define_property(this, "criteria", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLandscapeRequest, "runtime", proto3);
_define_property(CreateLandscapeRequest, "typeName", "mono.morgans.v1.CreateLandscapeRequest");
_define_property(CreateLandscapeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "organization_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "capabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "observed_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "criteria",
            kind: "message",
            T: LandscapeCriterionInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateLandscapeResponse
 */ export class CreateLandscapeResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateLandscapeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLandscapeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLandscapeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLandscapeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.Landscape landscape = 1;
   */ _define_property(this, "landscape", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLandscapeResponse, "runtime", proto3);
_define_property(CreateLandscapeResponse, "typeName", "mono.morgans.v1.CreateLandscapeResponse");
_define_property(CreateLandscapeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape",
            kind: "message",
            T: Landscape
        }
    ]));
/**
 * Full replace of the editable fields; criteria are diffed by (kind, value).
 *
 * @generated from message mono.morgans.v1.UpdateLandscapeRequest
 */ export class UpdateLandscapeRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateLandscapeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateLandscapeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateLandscapeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateLandscapeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string scope = 3;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: repeated string organization_ids = 4;
   */ _define_property(this, "organizationIds", []), /**
   * @generated from field: repeated string capabilities = 5;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: string context = 6;
   */ _define_property(this, "context", ""), /**
   * @generated from field: bool observed_only = 7;
   */ _define_property(this, "observedOnly", false), /**
   * @generated from field: repeated mono.morgans.v1.LandscapeCriterionInput criteria = 8;
   */ _define_property(this, "criteria", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateLandscapeRequest, "runtime", proto3);
_define_property(UpdateLandscapeRequest, "typeName", "mono.morgans.v1.UpdateLandscapeRequest");
_define_property(UpdateLandscapeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "organization_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "capabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "observed_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "criteria",
            kind: "message",
            T: LandscapeCriterionInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpdateLandscapeResponse
 */ export class UpdateLandscapeResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateLandscapeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateLandscapeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateLandscapeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateLandscapeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.Landscape landscape = 1;
   */ _define_property(this, "landscape", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateLandscapeResponse, "runtime", proto3);
_define_property(UpdateLandscapeResponse, "typeName", "mono.morgans.v1.UpdateLandscapeResponse");
_define_property(UpdateLandscapeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape",
            kind: "message",
            T: Landscape
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetLandscapeRequest
 */ export class GetLandscapeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeRequest, "runtime", proto3);
_define_property(GetLandscapeRequest, "typeName", "mono.morgans.v1.GetLandscapeRequest");
_define_property(GetLandscapeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetLandscapeResponse
 */ export class GetLandscapeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.Landscape landscape = 1;
   */ _define_property(this, "landscape", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeResponse, "runtime", proto3);
_define_property(GetLandscapeResponse, "typeName", "mono.morgans.v1.GetLandscapeResponse");
_define_property(GetLandscapeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape",
            kind: "message",
            T: Landscape
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListLandscapesRequest
 */ export class ListLandscapesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapesRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapesRequest, "runtime", proto3);
_define_property(ListLandscapesRequest, "typeName", "mono.morgans.v1.ListLandscapesRequest");
_define_property(ListLandscapesRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.ListLandscapesResponse
 */ export class ListLandscapesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.Landscape landscapes = 1;
   */ _define_property(this, "landscapes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapesResponse, "runtime", proto3);
_define_property(ListLandscapesResponse, "typeName", "mono.morgans.v1.ListLandscapesResponse");
_define_property(ListLandscapesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscapes",
            kind: "message",
            T: Landscape,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.LandscapeMember
 */ export class LandscapeMember extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeMember, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string opportunity_title = 4;
   */ _define_property(this, "opportunityTitle", ""), /**
   * "rule" | "manual"
   *
   * @generated from field: string basis = 5;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string rule_id = 6;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: mono.morgans.v1.LandscapeCriterionKind rule_kind = 7;
   */ _define_property(this, "ruleKind", 0), /**
   * @generated from field: string rule_value = 8;
   */ _define_property(this, "ruleValue", ""), /**
   * "active" | "removed"
   *
   * @generated from field: string state = 9;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string removed_by = 10;
   */ _define_property(this, "removedBy", ""), /**
   * @generated from field: string removal_reason = 11;
   */ _define_property(this, "removalReason", ""), /**
   * @generated from field: google.protobuf.Timestamp removed_at = 12;
   */ _define_property(this, "removedAt", void 0), /**
   * e.g. "suppressed by manual correction"; empty when not suppressed.
   *
   * @generated from field: string suppression_reason = 13;
   */ _define_property(this, "suppressionReason", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeMember, "runtime", proto3);
_define_property(LandscapeMember, "typeName", "mono.morgans.v1.LandscapeMember");
_define_property(LandscapeMember, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "opportunity_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rule_kind",
            kind: "enum",
            T: proto3.getEnumType(LandscapeCriterionKind)
        },
        {
            no: 8,
            name: "rule_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "removed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "removal_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "removed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "suppression_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListLandscapeMembersRequest
 */ export class ListLandscapeMembersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeMembersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeMembersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeMembersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeMembersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: bool include_removed = 2;
   */ _define_property(this, "includeRemoved", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeMembersRequest, "runtime", proto3);
_define_property(ListLandscapeMembersRequest, "typeName", "mono.morgans.v1.ListLandscapeMembersRequest");
_define_property(ListLandscapeMembersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListLandscapeMembersResponse
 */ export class ListLandscapeMembersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeMembersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeMembersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeMembersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeMembersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.LandscapeMember members = 1;
   */ _define_property(this, "members", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeMembersResponse, "runtime", proto3);
_define_property(ListLandscapeMembersResponse, "typeName", "mono.morgans.v1.ListLandscapeMembersResponse");
_define_property(ListLandscapeMembersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "members",
            kind: "message",
            T: LandscapeMember,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.AddLandscapeMemberRequest
 */ export class AddLandscapeMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddLandscapeMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddLandscapeMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddLandscapeMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddLandscapeMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddLandscapeMemberRequest, "runtime", proto3);
_define_property(AddLandscapeMemberRequest, "typeName", "mono.morgans.v1.AddLandscapeMemberRequest");
_define_property(AddLandscapeMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.AddLandscapeMemberResponse
 */ export class AddLandscapeMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddLandscapeMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddLandscapeMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddLandscapeMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddLandscapeMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.LandscapeMember member = 1;
   */ _define_property(this, "member", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddLandscapeMemberResponse, "runtime", proto3);
_define_property(AddLandscapeMemberResponse, "typeName", "mono.morgans.v1.AddLandscapeMemberResponse");
_define_property(AddLandscapeMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: LandscapeMember
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RemoveLandscapeMemberRequest
 */ export class RemoveLandscapeMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveLandscapeMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveLandscapeMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveLandscapeMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveLandscapeMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * Required.
   *
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveLandscapeMemberRequest, "runtime", proto3);
_define_property(RemoveLandscapeMemberRequest, "typeName", "mono.morgans.v1.RemoveLandscapeMemberRequest");
_define_property(RemoveLandscapeMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RemoveLandscapeMemberResponse
 */ export class RemoveLandscapeMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveLandscapeMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveLandscapeMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveLandscapeMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveLandscapeMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.LandscapeMember member = 1;
   */ _define_property(this, "member", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveLandscapeMemberResponse, "runtime", proto3);
_define_property(RemoveLandscapeMemberResponse, "typeName", "mono.morgans.v1.RemoveLandscapeMemberResponse");
_define_property(RemoveLandscapeMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: LandscapeMember
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RunLandscapeRulesRequest
 */ export class RunLandscapeRulesRequest extends Message {
    static fromBinary(bytes, options) {
        return new RunLandscapeRulesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunLandscapeRulesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunLandscapeRulesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunLandscapeRulesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunLandscapeRulesRequest, "runtime", proto3);
_define_property(RunLandscapeRulesRequest, "typeName", "mono.morgans.v1.RunLandscapeRulesRequest");
_define_property(RunLandscapeRulesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RunLandscapeRulesResponse
 */ export class RunLandscapeRulesResponse extends Message {
    static fromBinary(bytes, options) {
        return new RunLandscapeRulesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunLandscapeRulesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunLandscapeRulesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunLandscapeRulesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 added = 1;
   */ _define_property(this, "added", 0), /**
   * @generated from field: int32 resuggested = 2;
   */ _define_property(this, "resuggested", 0), /**
   * @generated from field: int32 suppressed = 3;
   */ _define_property(this, "suppressed", 0), /**
   * @generated from field: int32 unchanged = 4;
   */ _define_property(this, "unchanged", 0), /**
   * @generated from field: repeated string suppressed_opportunity_ids = 5;
   */ _define_property(this, "suppressedOpportunityIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunLandscapeRulesResponse, "runtime", proto3);
_define_property(RunLandscapeRulesResponse, "typeName", "mono.morgans.v1.RunLandscapeRulesResponse");
_define_property(RunLandscapeRulesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "added",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "resuggested",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "suppressed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "unchanged",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "suppressed_opportunity_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.LandscapeMemberEvent
 */ export class LandscapeMemberEvent extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeMemberEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeMemberEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeMemberEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeMemberEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * "rule_add" | "rule_resuggest" | "rule_suppressed" | "manual_add" | "manual_remove"
   *
   * @generated from field: string action = 4;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string basis = 5;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string rule_id = 6;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: string rule_fingerprint = 7;
   */ _define_property(this, "ruleFingerprint", ""), /**
   * @generated from field: string actor = 8;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string reason = 9;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeMemberEvent, "runtime", proto3);
_define_property(LandscapeMemberEvent, "typeName", "mono.morgans.v1.LandscapeMemberEvent");
_define_property(LandscapeMemberEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rule_fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListLandscapeMemberHistoryRequest
 */ export class ListLandscapeMemberHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeMemberHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeMemberHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeMemberHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeMemberHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeMemberHistoryRequest, "runtime", proto3);
_define_property(ListLandscapeMemberHistoryRequest, "typeName", "mono.morgans.v1.ListLandscapeMemberHistoryRequest");
_define_property(ListLandscapeMemberHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListLandscapeMemberHistoryResponse
 */ export class ListLandscapeMemberHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeMemberHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeMemberHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeMemberHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeMemberHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.LandscapeMemberEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeMemberHistoryResponse, "runtime", proto3);
_define_property(ListLandscapeMemberHistoryResponse, "typeName", "mono.morgans.v1.ListLandscapeMemberHistoryResponse");
_define_property(ListLandscapeMemberHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: LandscapeMemberEvent,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetLandscapeStoryRequest
 */ export class GetLandscapeStoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeStoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeStoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeStoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeStoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: bool include_removed = 2;
   */ _define_property(this, "includeRemoved", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeStoryRequest, "runtime", proto3);
_define_property(GetLandscapeStoryRequest, "typeName", "mono.morgans.v1.GetLandscapeStoryRequest");
_define_property(GetLandscapeStoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetLandscapeStoryResponse
 */ export class GetLandscapeStoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeStoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeStoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeStoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeStoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.LandscapeStoryThread threads = 1;
   */ _define_property(this, "threads", []), /**
   * Distinct permitted identities across all returned threads, including earlier work.
   *
   * @generated from field: int32 opportunity_count = 2;
   */ _define_property(this, "opportunityCount", 0), /**
   * @generated from field: int32 pursuit_count = 3;
   */ _define_property(this, "pursuitCount", 0), /**
   * @generated from field: int32 rfi_response_count = 4;
   */ _define_property(this, "rfiResponseCount", 0), /**
   * @generated from field: int32 proposal_count = 5;
   */ _define_property(this, "proposalCount", 0), /**
   * @generated from field: int32 program_count = 6;
   */ _define_property(this, "programCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeStoryResponse, "runtime", proto3);
_define_property(GetLandscapeStoryResponse, "typeName", "mono.morgans.v1.GetLandscapeStoryResponse");
_define_property(GetLandscapeStoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "threads",
            kind: "message",
            T: LandscapeStoryThread,
            repeated: true
        },
        {
            no: 2,
            name: "opportunity_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "pursuit_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "rfi_response_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "proposal_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "program_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * A canonical Opportunity is one business thread, regardless of work count.
 *
 * @generated from message mono.morgans.v1.LandscapeStoryThread
 */ export class LandscapeStoryThread extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeStoryThread().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeStoryThread().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeStoryThread().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeStoryThread, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string membership_state = 2;
   */ _define_property(this, "membershipState", ""), /**
   * @generated from field: repeated mono.morgans.v1.LandscapeStoryRecord records = 3;
   */ _define_property(this, "records", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeStoryThread, "runtime", proto3);
_define_property(LandscapeStoryThread, "typeName", "mono.morgans.v1.LandscapeStoryThread");
_define_property(LandscapeStoryThread, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "membership_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "records",
            kind: "message",
            T: LandscapeStoryRecord,
            repeated: true
        }
    ]));
/**
 * Reference metadata only: no raw notes, economics or Delivery finances.
 *
 * @generated from message mono.morgans.v1.LandscapeStoryRecord
 */ export class LandscapeStoryRecord extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeStoryRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeStoryRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeStoryRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeStoryRecord, a, b);
    }
    constructor(data){
        super(), /**
   * opportunity | notice | award | capture_project | rfi_response | proposal | program
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * Owning source's current status, never a universal lifecycle state.
   *
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * Whether the owning row/reference is live; stopped/lost status is retained.
   *
   * @generated from field: bool current = 5;
   */ _define_property(this, "current", false), /**
   * @generated from field: repeated mono.morgans.v1.LandscapeStoryEvent history = 6;
   */ _define_property(this, "history", []), /**
   * @generated from field: repeated mono.morgans.v1.LandscapeStoryEntity entities = 9;
   */ _define_property(this, "entities", []), /**
   * Recognized active owning-source states; unknown states remain history-only.
   *
   * @generated from field: bool current_work = 10;
   */ _define_property(this, "currentWork", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeStoryRecord, "runtime", proto3);
_define_property(LandscapeStoryRecord, "typeName", "mono.morgans.v1.LandscapeStoryRecord");
_define_property(LandscapeStoryRecord, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "current",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "history",
            kind: "message",
            T: LandscapeStoryEvent,
            repeated: true
        },
        {
            no: 9,
            name: "entities",
            kind: "message",
            T: LandscapeStoryEntity,
            repeated: true
        },
        {
            no: 10,
            name: "current_work",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.LandscapeStoryEvent
 */ export class LandscapeStoryEvent extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeStoryEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeStoryEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeStoryEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeStoryEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * market_published | company_action | learned_associated
   *
   * @generated from field: string category = 2;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string action = 3;
   */ _define_property(this, "action", ""), /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 4;
   */ _define_property(this, "occurredAt", void 0), /**
   * @generated from field: string source_table = 5;
   */ _define_property(this, "sourceTable", ""), /**
   * @generated from field: string source_id = 6;
   */ _define_property(this, "sourceId", ""), /**
   * @generated from field: string date_field = 7;
   */ _define_property(this, "dateField", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeStoryEvent, "runtime", proto3);
_define_property(LandscapeStoryEvent, "typeName", "mono.morgans.v1.LandscapeStoryEvent");
_define_property(LandscapeStoryEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "occurred_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "source_table",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "date_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Public/shared entity context from an authorized source record. An identifier
 * is present only when supplied by that source (e.g. an awardee UEI).
 *
 * @generated from message mono.morgans.v1.LandscapeStoryEntity
 */ export class LandscapeStoryEntity extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeStoryEntity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeStoryEntity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeStoryEntity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeStoryEntity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string identifier = 2;
   */ _define_property(this, "identifier", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string source_id = 4;
   */ _define_property(this, "sourceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeStoryEntity, "runtime", proto3);
_define_property(LandscapeStoryEntity, "typeName", "mono.morgans.v1.LandscapeStoryEntity");
_define_property(LandscapeStoryEntity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RunPublicDataFeedRequest
 */ export class RunPublicDataFeedRequest extends Message {
    static fromBinary(bytes, options) {
        return new RunPublicDataFeedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunPublicDataFeedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunPublicDataFeedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunPublicDataFeedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * "sba-mp"
   *
   * @generated from field: string feed = 1;
   */ _define_property(this, "feed", ""), /**
   * @generated from field: bool dry_run = 2;
   */ _define_property(this, "dryRun", false), /**
   * optional: refuse unless the discovered file has this name
   *
   * @generated from field: string file_name = 3;
   */ _define_property(this, "fileName", ""), /**
   * sba-mp: load even if the list shrank > 20% (audited)
   *
   * @generated from field: bool force_shrink = 4;
   */ _define_property(this, "forceShrink", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunPublicDataFeedRequest, "runtime", proto3);
_define_property(RunPublicDataFeedRequest, "typeName", "mono.morgans.v1.RunPublicDataFeedRequest");
_define_property(RunPublicDataFeedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "feed",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "force_shrink",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RunPublicDataFeedResponse
 */ export class RunPublicDataFeedResponse extends Message {
    static fromBinary(bytes, options) {
        return new RunPublicDataFeedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RunPublicDataFeedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RunPublicDataFeedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RunPublicDataFeedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", ""), /**
   * @generated from field: int32 rows_seen = 2;
   */ _define_property(this, "rowsSeen", 0), /**
   * @generated from field: int32 rows_loaded = 3;
   */ _define_property(this, "rowsLoaded", 0), /**
   * @generated from field: int32 rows_skipped = 4;
   */ _define_property(this, "rowsSkipped", 0), /**
   * YYYY-MM-DD
   *
   * @generated from field: string as_of = 5;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: int32 cert_tokens_unmapped = 6;
   */ _define_property(this, "certTokensUnmapped", 0), /**
   * loaded | unchanged | failed | dry_run
   *
   * @generated from field: string outcome = 7;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string failure_code = 8;
   */ _define_property(this, "failureCode", ""), /**
   * @generated from field: string file_name = 9;
   */ _define_property(this, "fileName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RunPublicDataFeedResponse, "runtime", proto3);
_define_property(RunPublicDataFeedResponse, "typeName", "mono.morgans.v1.RunPublicDataFeedResponse");
_define_property(RunPublicDataFeedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rows_seen",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "rows_loaded",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "rows_skipped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "cert_tokens_unmapped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "failure_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetLandscapeSeatsRequest
 */ export class GetLandscapeSeatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeSeatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeSeatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeSeatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeSeatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeSeatsRequest, "runtime", proto3);
_define_property(GetLandscapeSeatsRequest, "typeName", "mono.morgans.v1.GetLandscapeSeatsRequest");
_define_property(GetLandscapeSeatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetLandscapeSeatsResponse
 */ export class GetLandscapeSeatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeSeatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeSeatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeSeatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeSeatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Seat seats = 1;
   */ _define_property(this, "seats", []), /**
   * opportunity_activities of member opportunities, by month
   *
   * @generated from field: repeated mono.datagateway.v1.MarketDensityPoint market = 2;
   */ _define_property(this, "market", []), /**
   * @generated from field: int32 market_total = 3;
   */ _define_property(this, "marketTotal", 0), /**
   * @generated from field: bool can_edit = 4;
   */ _define_property(this, "canEdit", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeSeatsResponse, "runtime", proto3);
_define_property(GetLandscapeSeatsResponse, "typeName", "mono.morgans.v1.GetLandscapeSeatsResponse");
_define_property(GetLandscapeSeatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seats",
            kind: "message",
            T: Seat,
            repeated: true
        },
        {
            no: 2,
            name: "market",
            kind: "message",
            T: MarketDensityPoint,
            repeated: true
        },
        {
            no: 3,
            name: "market_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "can_edit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListSeatsRequest
 */ export class ListSeatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSeatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSeatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSeatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSeatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string customer_org_id = 2;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string landscape_id = 3;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string search = 4;
   */ _define_property(this, "search", ""), /**
   * @generated from field: bool include_archived = 5;
   */ _define_property(this, "includeArchived", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSeatsRequest, "runtime", proto3);
_define_property(ListSeatsRequest, "typeName", "mono.morgans.v1.ListSeatsRequest");
_define_property(ListSeatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "include_archived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListSeatsResponse
 */ export class ListSeatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSeatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSeatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSeatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSeatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Seat seats = 1;
   */ _define_property(this, "seats", []), /**
   * @generated from field: bool growth_hidden = 2;
   */ _define_property(this, "growthHidden", false), /**
   * @generated from field: bool growth_presence = 3;
   */ _define_property(this, "growthPresence", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSeatsResponse, "runtime", proto3);
_define_property(ListSeatsResponse, "typeName", "mono.morgans.v1.ListSeatsResponse");
_define_property(ListSeatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seats",
            kind: "message",
            T: Seat,
            repeated: true
        },
        {
            no: 2,
            name: "growth_hidden",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "growth_presence",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpsertSeatRequest
 */ export class UpsertSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Seat seat = 1;
   */ _define_property(this, "seat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSeatRequest, "runtime", proto3);
_define_property(UpsertSeatRequest, "typeName", "mono.morgans.v1.UpsertSeatRequest");
_define_property(UpsertSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat",
            kind: "message",
            T: Seat
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpsertSeatResponse
 */ export class UpsertSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSeatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Seat seat = 1;
   */ _define_property(this, "seat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSeatResponse, "runtime", proto3);
_define_property(UpsertSeatResponse, "typeName", "mono.morgans.v1.UpsertSeatResponse");
_define_property(UpsertSeatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat",
            kind: "message",
            T: Seat
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpsertSeatRoundRequest
 */ export class UpsertSeatRoundRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSeatRoundRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSeatRoundRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSeatRoundRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSeatRoundRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string seat_id = 1;
   */ _define_property(this, "seatId", ""), /**
   * @generated from field: mono.datagateway.v1.SeatRound round = 2;
   */ _define_property(this, "round", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSeatRoundRequest, "runtime", proto3);
_define_property(UpsertSeatRoundRequest, "typeName", "mono.morgans.v1.UpsertSeatRoundRequest");
_define_property(UpsertSeatRoundRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "round",
            kind: "message",
            T: SeatRound
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpsertSeatRoundResponse
 */ export class UpsertSeatRoundResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSeatRoundResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSeatRoundResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSeatRoundResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSeatRoundResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SeatRound round = 1;
   */ _define_property(this, "round", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSeatRoundResponse, "runtime", proto3);
_define_property(UpsertSeatRoundResponse, "typeName", "mono.morgans.v1.UpsertSeatRoundResponse");
_define_property(UpsertSeatRoundResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "round",
            kind: "message",
            T: SeatRound
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ArchiveSeatRoundRequest
 */ export class ArchiveSeatRoundRequest extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveSeatRoundRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveSeatRoundRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveSeatRoundRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveSeatRoundRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string round_id = 1;
   */ _define_property(this, "roundId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveSeatRoundRequest, "runtime", proto3);
_define_property(ArchiveSeatRoundRequest, "typeName", "mono.morgans.v1.ArchiveSeatRoundRequest");
_define_property(ArchiveSeatRoundRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "round_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ArchiveSeatRoundResponse
 */ export class ArchiveSeatRoundResponse extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveSeatRoundResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveSeatRoundResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveSeatRoundResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveSeatRoundResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveSeatRoundResponse, "runtime", proto3);
_define_property(ArchiveSeatRoundResponse, "typeName", "mono.morgans.v1.ArchiveSeatRoundResponse");
_define_property(ArchiveSeatRoundResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.SetLandscapeSeatRequest
 */ export class SetLandscapeSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetLandscapeSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetLandscapeSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetLandscapeSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetLandscapeSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string seat_id = 2;
   */ _define_property(this, "seatId", ""), /**
   * @generated from field: bool member = 3;
   */ _define_property(this, "member", false), /**
   * @generated from field: int32 sort_order = 4;
   */ _define_property(this, "sortOrder", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetLandscapeSeatRequest, "runtime", proto3);
_define_property(SetLandscapeSeatRequest, "typeName", "mono.morgans.v1.SetLandscapeSeatRequest");
_define_property(SetLandscapeSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "member",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SetLandscapeSeatResponse
 */ export class SetLandscapeSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetLandscapeSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetLandscapeSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetLandscapeSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetLandscapeSeatResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetLandscapeSeatResponse, "runtime", proto3);
_define_property(SetLandscapeSeatResponse, "typeName", "mono.morgans.v1.SetLandscapeSeatResponse");
_define_property(SetLandscapeSeatResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.morgans.v1.SplitSeatRequest
 */ export class SplitSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new SplitSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SplitSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SplitSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SplitSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string seat_id = 1;
   */ _define_property(this, "seatId", ""), /**
   * @generated from field: string new_name = 2;
   */ _define_property(this, "newName", ""), /**
   * @generated from field: string split_on = 3;
   */ _define_property(this, "splitOn", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SplitSeatRequest, "runtime", proto3);
_define_property(SplitSeatRequest, "typeName", "mono.morgans.v1.SplitSeatRequest");
_define_property(SplitSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "new_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "split_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SplitSeatResponse
 */ export class SplitSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new SplitSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SplitSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SplitSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SplitSeatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Seat seat = 1;
   */ _define_property(this, "seat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SplitSeatResponse, "runtime", proto3);
_define_property(SplitSeatResponse, "typeName", "mono.morgans.v1.SplitSeatResponse");
_define_property(SplitSeatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat",
            kind: "message",
            T: Seat
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SuggestSeatRoundsRequest
 */ export class SuggestSeatRoundsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SuggestSeatRoundsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestSeatRoundsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestSeatRoundsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestSeatRoundsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string seat_id = 1;
   */ _define_property(this, "seatId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestSeatRoundsRequest, "runtime", proto3);
_define_property(SuggestSeatRoundsRequest, "typeName", "mono.morgans.v1.SuggestSeatRoundsRequest");
_define_property(SuggestSeatRoundsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.SuggestSeatRoundsResponse
 */ export class SuggestSeatRoundsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SuggestSeatRoundsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestSeatRoundsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestSeatRoundsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestSeatRoundsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SuggestedRound suggestions = 1;
   */ _define_property(this, "suggestions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestSeatRoundsResponse, "runtime", proto3);
_define_property(SuggestSeatRoundsResponse, "typeName", "mono.morgans.v1.SuggestSeatRoundsResponse");
_define_property(SuggestSeatRoundsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "suggestions",
            kind: "message",
            T: SuggestedRound,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MorgansMergeSeatsRequest
 */ export class MorgansMergeSeatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new MorgansMergeSeatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MorgansMergeSeatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MorgansMergeSeatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MorgansMergeSeatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string loser_seat_id = 1;
   */ _define_property(this, "loserSeatId", ""), /**
   * @generated from field: string survivor_seat_id = 2;
   */ _define_property(this, "survivorSeatId", ""), /**
   * @generated from field: string merged_on = 3;
   */ _define_property(this, "mergedOn", ""), /**
   * @generated from field: string landscape_id = 4;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MorgansMergeSeatsRequest, "runtime", proto3);
_define_property(MorgansMergeSeatsRequest, "typeName", "mono.morgans.v1.MorgansMergeSeatsRequest");
_define_property(MorgansMergeSeatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "loser_seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "survivor_seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "merged_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MorgansMergeSeatsResponse
 */ export class MorgansMergeSeatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new MorgansMergeSeatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MorgansMergeSeatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MorgansMergeSeatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MorgansMergeSeatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Seat survivor = 1;
   */ _define_property(this, "survivor", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MorgansMergeSeatsResponse, "runtime", proto3);
_define_property(MorgansMergeSeatsResponse, "typeName", "mono.morgans.v1.MorgansMergeSeatsResponse");
_define_property(MorgansMergeSeatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "survivor",
            kind: "message",
            T: Seat
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MorgansUnmergeSeatRequest
 */ export class MorgansUnmergeSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new MorgansUnmergeSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MorgansUnmergeSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MorgansUnmergeSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MorgansUnmergeSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string seat_id = 1;
   */ _define_property(this, "seatId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MorgansUnmergeSeatRequest, "runtime", proto3);
_define_property(MorgansUnmergeSeatRequest, "typeName", "mono.morgans.v1.MorgansUnmergeSeatRequest");
_define_property(MorgansUnmergeSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.MorgansUnmergeSeatResponse
 */ export class MorgansUnmergeSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new MorgansUnmergeSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MorgansUnmergeSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MorgansUnmergeSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MorgansUnmergeSeatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Seat seat = 1;
   */ _define_property(this, "seat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MorgansUnmergeSeatResponse, "runtime", proto3);
_define_property(MorgansUnmergeSeatResponse, "typeName", "mono.morgans.v1.MorgansUnmergeSeatResponse");
_define_property(MorgansUnmergeSeatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat",
            kind: "message",
            T: Seat
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CountNoticesForOfficesRequest
 */ export class CountNoticesForOfficesRequest extends Message {
    static fromBinary(bytes, options) {
        return new CountNoticesForOfficesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CountNoticesForOfficesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CountNoticesForOfficesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CountNoticesForOfficesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * v2.3: unresolved observed codes only (match keys)
   *
   * @generated from field: repeated string office_codes = 1;
   */ _define_property(this, "officeCodes", []), /**
   * YYYY-MM-DD; empty = all history
   *
   * @generated from field: string since = 2;
   */ _define_property(this, "since", ""), /**
   * v2.3: preferred; REG-24's parent_id-CTE org set, 1..500
   *
   * @generated from field: repeated string government_organization_ids = 3;
   */ _define_property(this, "governmentOrganizationIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CountNoticesForOfficesRequest, "runtime", proto3);
_define_property(CountNoticesForOfficesRequest, "typeName", "mono.morgans.v1.CountNoticesForOfficesRequest");
_define_property(CountNoticesForOfficesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "office_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "since",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "government_organization_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.OfficeNoticeCount
 */ export class OfficeNoticeCount extends Message {
    static fromBinary(bytes, options) {
        return new OfficeNoticeCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OfficeNoticeCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OfficeNoticeCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OfficeNoticeCount, a, b);
    }
    constructor(data){
        super(), /**
   * set only for code-mode rows
   *
   * @generated from field: string office_code = 1;
   */ _define_property(this, "officeCode", ""), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: int32 open_now = 3;
   */ _define_property(this, "openNow", 0), /**
   * @generated from field: string first_posted = 4;
   */ _define_property(this, "firstPosted", ""), /**
   * v2.3: set for org-mode rows (the requested survivor id)
   *
   * @generated from field: string government_organization_id = 5;
   */ _define_property(this, "governmentOrganizationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OfficeNoticeCount, "runtime", proto3);
_define_property(OfficeNoticeCount, "typeName", "mono.morgans.v1.OfficeNoticeCount");
_define_property(OfficeNoticeCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "office_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "open_now",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "first_posted",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CountNoticesForOfficesResponse
 */ export class CountNoticesForOfficesResponse extends Message {
    static fromBinary(bytes, options) {
        return new CountNoticesForOfficesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CountNoticesForOfficesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CountNoticesForOfficesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CountNoticesForOfficesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.OfficeNoticeCount counts = 1;
   */ _define_property(this, "counts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CountNoticesForOfficesResponse, "runtime", proto3);
_define_property(CountNoticesForOfficesResponse, "typeName", "mono.morgans.v1.CountNoticesForOfficesResponse");
_define_property(CountNoticesForOfficesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "counts",
            kind: "message",
            T: OfficeNoticeCount,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListNoticesForVehicleRequest
 */ export class ListNoticesForVehicleRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticesForVehicleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticesForVehicleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticesForVehicleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticesForVehicleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: bool open_only = 2;
   */ _define_property(this, "openOnly", false), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticesForVehicleRequest, "runtime", proto3);
_define_property(ListNoticesForVehicleRequest, "typeName", "mono.morgans.v1.ListNoticesForVehicleRequest");
_define_property(ListNoticesForVehicleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "open_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.VehicleNotice
 */ export class VehicleNotice extends Message {
    static fromBinary(bytes, options) {
        return new VehicleNotice().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleNotice().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleNotice().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleNotice, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string type_label = 3;
   */ _define_property(this, "typeLabel", ""), /**
   * @generated from field: string posted_at = 4;
   */ _define_property(this, "postedAt", ""), /**
   * @generated from field: string response_due = 5;
   */ _define_property(this, "responseDue", ""), /**
   * @generated from field: string office_name = 6;
   */ _define_property(this, "officeName", ""), /**
   * @generated from field: string basis = 7;
   */ _define_property(this, "basis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleNotice, "runtime", proto3);
_define_property(VehicleNotice, "typeName", "mono.morgans.v1.VehicleNotice");
_define_property(VehicleNotice, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "posted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "response_due",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "office_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListNoticesForVehicleResponse
 */ export class ListNoticesForVehicleResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticesForVehicleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticesForVehicleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticesForVehicleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticesForVehicleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.VehicleNotice notices = 1;
   */ _define_property(this, "notices", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticesForVehicleResponse, "runtime", proto3);
_define_property(ListNoticesForVehicleResponse, "typeName", "mono.morgans.v1.ListNoticesForVehicleResponse");
_define_property(ListNoticesForVehicleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notices",
            kind: "message",
            T: VehicleNotice,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListVehicleNoticesRequest
 */ export class ListVehicleNoticesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleNoticesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleNoticesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleNoticesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleNoticesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: bool open_only = 2;
   */ _define_property(this, "openOnly", false), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleNoticesRequest, "runtime", proto3);
_define_property(ListVehicleNoticesRequest, "typeName", "mono.morgans.v1.ListVehicleNoticesRequest");
_define_property(ListVehicleNoticesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "open_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.VehicleNoticeRow
 */ export class VehicleNoticeRow extends Message {
    static fromBinary(bytes, options) {
        return new VehicleNoticeRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleNoticeRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleNoticeRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleNoticeRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string notice_type = 3;
   */ _define_property(this, "noticeType", ""), /**
   * unset = no stored deadline
   *
   * @generated from field: google.protobuf.Timestamp response_due = 4;
   */ _define_property(this, "responseDue", void 0), /**
   * WATCHING rows only
   *
   * @generated from field: optional string pursuit_opportunity_id = 5;
   */ _define_property(this, "pursuitOpportunityId", void 0), /**
   * @generated from field: mono.morgans.v1.VehicleNoticeStatus status = 6;
   */ _define_property(this, "status", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleNoticeRow, "runtime", proto3);
_define_property(VehicleNoticeRow, "typeName", "mono.morgans.v1.VehicleNoticeRow");
_define_property(VehicleNoticeRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "response_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "pursuit_opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "status",
            kind: "enum",
            T: proto3.getEnumType(VehicleNoticeStatus)
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListVehicleNoticesResponse
 */ export class ListVehicleNoticesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleNoticesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleNoticesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleNoticesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleNoticesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.VehicleNoticeRow notices = 1;
   */ _define_property(this, "notices", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleNoticesResponse, "runtime", proto3);
_define_property(ListVehicleNoticesResponse, "typeName", "mono.morgans.v1.ListVehicleNoticesResponse");
_define_property(ListVehicleNoticesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notices",
            kind: "message",
            T: VehicleNoticeRow,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetGovOrgNoticeSummaryRequest
 */ export class GetGovOrgNoticeSummaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGovOrgNoticeSummaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovOrgNoticeSummaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovOrgNoticeSummaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovOrgNoticeSummaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string government_organization_id = 1;
   */ _define_property(this, "governmentOrganizationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovOrgNoticeSummaryRequest, "runtime", proto3);
_define_property(GetGovOrgNoticeSummaryRequest, "typeName", "mono.morgans.v1.GetGovOrgNoticeSummaryRequest");
_define_property(GetGovOrgNoticeSummaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetGovOrgNoticeSummaryResponse
 */ export class GetGovOrgNoticeSummaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGovOrgNoticeSummaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovOrgNoticeSummaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovOrgNoticeSummaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovOrgNoticeSummaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 total_since_year = 1;
   */ _define_property(this, "totalSinceYear", 0), /**
   * @generated from field: int32 since_year = 2;
   */ _define_property(this, "sinceYear", 0), /**
   * @generated from field: int32 open_now = 3;
   */ _define_property(this, "openNow", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovOrgNoticeSummaryResponse, "runtime", proto3);
_define_property(GetGovOrgNoticeSummaryResponse, "typeName", "mono.morgans.v1.GetGovOrgNoticeSummaryResponse");
_define_property(GetGovOrgNoticeSummaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_since_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "since_year",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "open_now",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CountNoticesForGovOrgsRequest
 */ export class CountNoticesForGovOrgsRequest extends Message {
    static fromBinary(bytes, options) {
        return new CountNoticesForGovOrgsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CountNoticesForGovOrgsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CountNoticesForGovOrgsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CountNoticesForGovOrgsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string government_organization_ids = 1;
   */ _define_property(this, "governmentOrganizationIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CountNoticesForGovOrgsRequest, "runtime", proto3);
_define_property(CountNoticesForGovOrgsRequest, "typeName", "mono.morgans.v1.CountNoticesForGovOrgsRequest");
_define_property(CountNoticesForGovOrgsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "government_organization_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GovOrgNoticeCount
 */ export class GovOrgNoticeCount extends Message {
    static fromBinary(bytes, options) {
        return new GovOrgNoticeCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovOrgNoticeCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovOrgNoticeCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovOrgNoticeCount, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string government_organization_id = 1;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: int32 notices_total = 2;
   */ _define_property(this, "noticesTotal", 0), /**
   * @generated from field: int32 notices_open = 3;
   */ _define_property(this, "noticesOpen", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovOrgNoticeCount, "runtime", proto3);
_define_property(GovOrgNoticeCount, "typeName", "mono.morgans.v1.GovOrgNoticeCount");
_define_property(GovOrgNoticeCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notices_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "notices_open",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CountNoticesForGovOrgsResponse
 */ export class CountNoticesForGovOrgsResponse extends Message {
    static fromBinary(bytes, options) {
        return new CountNoticesForGovOrgsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CountNoticesForGovOrgsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CountNoticesForGovOrgsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CountNoticesForGovOrgsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.GovOrgNoticeCount counts = 1;
   */ _define_property(this, "counts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CountNoticesForGovOrgsResponse, "runtime", proto3);
_define_property(CountNoticesForGovOrgsResponse, "typeName", "mono.morgans.v1.CountNoticesForGovOrgsResponse");
_define_property(CountNoticesForGovOrgsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "counts",
            kind: "message",
            T: GovOrgNoticeCount,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListNoticeContactsRequest
 */ export class ListNoticeContactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticeContactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticeContactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticeContactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticeContactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticeContactsRequest, "runtime", proto3);
_define_property(ListNoticeContactsRequest, "typeName", "mono.morgans.v1.ListNoticeContactsRequest");
_define_property(ListNoticeContactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * v2.3: each NoticeContact is a public OBSERVATION read from morgans' contacts table; nothing is stored in pangaea.
 *
 * @generated from message mono.morgans.v1.NoticeContact
 */ export class NoticeContact extends Message {
    static fromBinary(bytes, options) {
        return new NoticeContact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoticeContact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoticeContact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoticeContact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string full_name = 1;
   */ _define_property(this, "fullName", ""), /**
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 3;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * primary|secondary
   *
   * @generated from field: string type = 5;
   */ _define_property(this, "type", ""), /**
   * v2.3: survivor id when ResolveEntities{MATCH_ONLY, email} matched in the caller's tenant; '' otherwise
   *
   * @generated from field: string contact_id = 6;
   */ _define_property(this, "contactId", ""), /**
   * v2.3: MATCHED | UNRESOLVED (no email -> UNRESOLVED; a name never matches)
   *
   * @generated from field: string resolution = 7;
   */ _define_property(this, "resolution", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(NoticeContact, "runtime", proto3);
_define_property(NoticeContact, "typeName", "mono.morgans.v1.NoticeContact");
_define_property(NoticeContact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "full_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "resolution",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListNoticeContactsResponse
 */ export class ListNoticeContactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticeContactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticeContactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticeContactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticeContactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.NoticeContact contacts = 1;
   */ _define_property(this, "contacts", []), /**
   * observed code (match key)
   *
   * @generated from field: string office_code = 2;
   */ _define_property(this, "officeCode", ""), /**
   * v2.3: registry row name when linked, else morgans opportunities.office (observation)
   *
   * @generated from field: string office_name = 3;
   */ _define_property(this, "officeName", ""), /**
   * @generated from field: string posted_at = 4;
   */ _define_property(this, "postedAt", ""), /**
   * v2.3: the _system link from notice_offices; '' when unresolved
   *
   * @generated from field: string government_organization_id = 5;
   */ _define_property(this, "governmentOrganizationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticeContactsResponse, "runtime", proto3);
_define_property(ListNoticeContactsResponse, "typeName", "mono.morgans.v1.ListNoticeContactsResponse");
_define_property(ListNoticeContactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contacts",
            kind: "message",
            T: NoticeContact,
            repeated: true
        },
        {
            no: 2,
            name: "office_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "office_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "posted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ReparseStoredNoticesRequest
 */ export class ReparseStoredNoticesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReparseStoredNoticesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReparseStoredNoticesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReparseStoredNoticesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReparseStoredNoticesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string since = 1;
   */ _define_property(this, "since", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReparseStoredNoticesRequest, "runtime", proto3);
_define_property(ReparseStoredNoticesRequest, "typeName", "mono.morgans.v1.ReparseStoredNoticesRequest");
_define_property(ReparseStoredNoticesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "since",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ReparseStoredNoticesResponse
 */ export class ReparseStoredNoticesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReparseStoredNoticesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReparseStoredNoticesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReparseStoredNoticesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReparseStoredNoticesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string job_id = 1;
   */ _define_property(this, "jobId", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReparseStoredNoticesResponse, "runtime", proto3);
_define_property(ReparseStoredNoticesResponse, "typeName", "mono.morgans.v1.ReparseStoredNoticesResponse");
_define_property(ReparseStoredNoticesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RefreshCalcPlusBenchmarksRequest
 */ export class RefreshCalcPlusBenchmarksRequest extends Message {
    static fromBinary(bytes, options) {
        return new RefreshCalcPlusBenchmarksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshCalcPlusBenchmarksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshCalcPlusBenchmarksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshCalcPlusBenchmarksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated string contract_numbers = 2;
   */ _define_property(this, "contractNumbers", []), /**
   * @generated from field: repeated string vendor_name_fragments = 3;
   */ _define_property(this, "vendorNameFragments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshCalcPlusBenchmarksRequest, "runtime", proto3);
_define_property(RefreshCalcPlusBenchmarksRequest, "typeName", "mono.morgans.v1.RefreshCalcPlusBenchmarksRequest");
_define_property(RefreshCalcPlusBenchmarksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "vendor_name_fragments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.RefreshCalcPlusBenchmarksResponse
 */ export class RefreshCalcPlusBenchmarksResponse extends Message {
    static fromBinary(bytes, options) {
        return new RefreshCalcPlusBenchmarksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshCalcPlusBenchmarksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshCalcPlusBenchmarksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshCalcPlusBenchmarksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 rows = 1;
   */ _define_property(this, "rows", 0), /**
   * @generated from field: repeated string vendors_missing = 2;
   */ _define_property(this, "vendorsMissing", []), /**
   * @generated from field: repeated string vendors_ambiguous = 3;
   */ _define_property(this, "vendorsAmbiguous", []), /**
   * @generated from field: bool budget_exhausted = 4;
   */ _define_property(this, "budgetExhausted", false), /**
   * RFC3339 UTC; row provenance retains each page's retrieval time
   *
   * @generated from field: string retrieved_at = 5;
   */ _define_property(this, "retrievedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshCalcPlusBenchmarksResponse, "runtime", proto3);
_define_property(RefreshCalcPlusBenchmarksResponse, "typeName", "mono.morgans.v1.RefreshCalcPlusBenchmarksResponse");
_define_property(RefreshCalcPlusBenchmarksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "vendors_missing",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "vendors_ambiguous",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "budget_exhausted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "retrieved_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
